import { AxiosError, AxiosResponse } from "axios";
import { IGetListRequest, IResponse, IServerError } from "../models/common";
import { IPayroll, IPayrollListPayload, IPayrollResponse } from "../models";
import {
	ITimeSheetCategories,
	ITimeSheetCategoriesListPayload,
	ITimeSheetCategoriesResponse,
} from "../models/TimeSheetCategories";
import {
	ITimeSheetCategoryTrackingListPayload,
	ITimeSheetCategoryTrackingResponse,
} from "../models/TimeSheetCategoryTracking";

import { IDropDownListResponse } from "../models/common/IDropDownListResponse";
import { IPayrollAdjustmentAddEmployeePanel } from "../components/PayrollAdjustment/Panels/PayrollAdjustmentAddEmployeePanel";
import { IPayrollYearToDateAddEmployeePanel } from "../models/YearToDate/PayrollYearToDate/IPayrollYearToDateAddEmployeePanel";
import { ITimeSheetCategoryTracking } from "../components/TimeSheetCategoryTracking";
import { format422Errors } from "../common/Common";
import http from "../common/http-commons";

export const PayrollService = {
	getCombineClientDetailsAndFrequencyDDL: async (
		clientId: string,
		taxYear: number,
	): Promise<any | IServerError | IResponse | IPayrollResponse[] | null> => {
		try {
			const response: AxiosResponse<any> = await http.get<any>(
				`/v1/clients/client_details_for_payroll/${clientId}/combine_apis/for_payroll/?tax_year=${taxYear}`,
			);
			if (response.status === 200) {
				return response.data;
			} else if (response.status === 400) {
				return {
					status: false,
					message: "Bad Request.",
					error: true,
				};
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}
			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			return {
				status: false,
				message: errorMessage,
			};
		}
	},
	getPayroll: async (
		clientId: string,
		payPeriodFrequencyId: string | null,
		payPeriodStarDate: string | null,
		payPeriodEndDate: string | null,
		name: string,
		startsWith: string,
		department: string,
		paidBy: string,
		pageSize: number,
		page: number,
		data: IGetListRequest,
		navigateToLogout: (path: string) => void,
	): Promise<
		IPayrollListPayload | IServerError | IResponse | IPayrollResponse[] | null
	> => {
		if (payPeriodFrequencyId && payPeriodStarDate && payPeriodEndDate) {
			try {
				const response: AxiosResponse<IPayrollListPayload> =
					await http.get<IPayrollListPayload>(
						// "/v1/employee-payroll-data/?client_id=" +
						// 	clientId +
						// 	"&pay_period_frequency_id=" +
						// 	payPeriodFrequencyId +
						// 	"&pay_period_star_date=" +
						// 	payPeriodStarDate +
						// 	"&pay_period_end_date=" +
						// 	payPeriodEndDate +
						// 	"&search_query=" +
						// 	data.search_query +
						// 	"&order_by=" +
						// 	data.order_by +
						// 	"&order_direction=" +
						// 	data.order_direction +
						// 	"&page=" +
						// 	data.page +
						// 	"&size=" +
						// 	data.size,
						`/v1/employee-payroll-data/?client_id=` +
							clientId +
							`&pay_period_frequency_id=` +
							payPeriodFrequencyId +
							"&pay_period_star_date=" +
							payPeriodStarDate +
							"&pay_period_end_date=" +
							payPeriodEndDate +
							"&search_query=" +
							data.search_query +
							"&order_by=" +
							name +
							"&order_direction=" +
							data.order_direction +
							"&starts_with=" +
							startsWith +
							"&department=" +
							department +
							"&paid_by=" +
							paidBy +
							"&page=" +
							page +
							"&size=" +
							pageSize,
					);
				if (response.status === 200) {
					return response.data;
				} else if (response.status === 201) {
					return response.data;
				} else if (response.status === 400) {
					return {
						status: false,
						message: "Bad Request.",
						error: true,
					};
				} else if (response.status === 500) {
					return {
						status: false,
						message: "Something went wrong.",
						error: true,
					};
				}
				return {
					status: false,
					message: "Something went wrong please try again later.",
				};
			} catch (error) {
				const axiosError = error as AxiosError;
				console.error("An error occurred:", axiosError);
				const errorMessage =
					axiosError.response && typeof axiosError.response.data === "string"
						? axiosError.response.data
						: "Unknown error";
				if (axiosError && axiosError.status === 401) {
					navigateToLogout("/logout");
					return {
						status: false,
						message: "UnAuthrized",
					};
				} else {
					return {
						status: false,
						message: errorMessage,
					};
				}
			}
		}

		return null;

		// const fixedResponse: any = {
		//   page: 1,
		//   size: 25,
		//   rowSelection: true,
		//   total: 1,
		//   items: [
		//     {
		//       employeeName: "Tipu Sultan",
		//       employeeNumberId: "",
		//       provinceId: "67bd7102b5278a5ae5018ca3",
		//       province: {
		//         id: "67bd7102b5278a5ae5018ca3",
		//         name: "Alberta",
		//         shortCode: "AB",
		//       },
		//       dateOfHire: "2025-01-01",
		//       payPeriod: 12,
		//       payMethod: 100,
		//       salaryProfileMessage: null,
		//       td1Prov: "Exist",
		//       td1Fed: "Exist",
		//       employeeId: "69425242f639c2c0be9b2aa4",
		//       cppQppExempt: true,
		//       eiExempt: true,
		//       qpipExempt: false,
		//       federalTaxExempt: false,
		//       provisionalTaxExempt: false,
		//       hourlyRate: 2.2222222222222223,
		//       regularHoursData: 4.5,
		//       erdEarning: [],
		//       erdReimbursement: [],
		//       erdDeduction: [],
		//       commission: 0.0,
		//       retroactivePayIncrease: 0.0,
		//       nonPeriodicPayment: 0.0,
		//       bonus: 0.0,
		//       holidayPay: 0.0,
		//       holidayPayAccured: 0.0,
		//       vacationPay: 0.0,
		//       ot2Dot0Hours: null,
		//       ot1Dot5Hours: null,
		//       grossIncome: 199.0,
		//       regularHours: null,
		//       vacationPayAccured: 7.96,
		//       holidayHours: 0.0,
		//       isPayrollCalculated: false,

		//       hourlyPayRate: 4.4,
		//       vocationable: [
		//         "regularGross",
		//         "regularHours",
		//         "vacationPay",
		//         "commission",
		//         "ot1Dot5Hours",
		//         "ot2Dot0Hours",
		//         "grossIncome",
		//         "earning",
		//       ],
		//     },
		//   ],
		//   keyField: {
		//     field: "id",
		//     templateUrl: "/payroll/setup/id",
		//   },
		//   headerColumns: [
		//     {
		//       field: "employeeNumberId",
		//       headerName: "ID",
		//       description: "",
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       type: "text",
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       isEditable: false,
		//       sequence: 0,
		//       frozenColumn: true,
		//       footer: null,
		//       minWidth: null,
		//       maxWidth: 50,
		//       fieldName: null,
		//       edr: "edr",
		//     },
		//     {
		//       field: "employeeName",
		//       headerName: "Name",
		//       description: "",
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       type: "text",
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       isEditable: false,
		//       sequence: 1,
		//       frozenColumn: true,
		//       footer: "Total",
		//       minWidth: null,
		//       maxWidth: 150,
		//       fieldName: null,
		//       edr: "edr",
		//     },
		//     {
		//       field: "grossIncome",
		//       headerName: "Gross",
		//       description: "",
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       type: "number",
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       isEditable: true,
		//       sequence: 2,
		//       frozenColumn: false,
		//       footer: "100.00",
		//       minWidth: null,
		//       maxWidth: 120,
		//       fieldName: null,
		//       edr: "edr",
		//     },
		//     {
		//       field: "regularHours",
		//       headerName: "Reg. Hours",
		//       description: "",
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       type: "number",
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       isEditable: true,
		//       sequence: 3,
		//       frozenColumn: false,
		//       footer: "0.00",
		//       minWidth: null,
		//       maxWidth: 120,
		//       fieldName: null,
		//       edr: "edr",
		//     },
		//     {
		//       field: "ot1Dot5Hours",
		//       headerName: "OT 1.5",
		//       description: "",
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       type: "number",
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       isEditable: true,
		//       sequence: 4,
		//       frozenColumn: false,
		//       footer: "100.00",
		//       minWidth: null,
		//       maxWidth: 120,
		//       fieldName: null,
		//       edr: "edr",
		//     },
		//     {
		//       field: "ot2Dot0Hours",
		//       headerName: "OT 2.0",
		//       description: "",
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       type: "number",
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       isEditable: true,
		//       sequence: 4,
		//       frozenColumn: false,
		//       footer: "100.00",
		//       minWidth: null,
		//       maxWidth: 120,
		//       fieldName: null,
		//       edr: "edr",
		//     },
		//     {
		//       field: "total",
		//       headerName: "Total",
		//       description: "",
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       type: "text",
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       isEditable: false,
		//       sequence: 4,
		//       frozenColumn: false,
		//       footer: "100.00",
		//       minWidth: null,
		//       maxWidth: 150,
		//       fieldName: null,
		//       edr: "edr",
		//     },
		//     {
		//       field: "vacationPay",
		//       headerName: "Vacation Pay",
		//       description: "",
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       type: "number",
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       isEditable: true,
		//       sequence: 4,
		//       frozenColumn: false,
		//       footer: "100.00",
		//       minWidth: null,
		//       maxWidth: 120,
		//       fieldName: null,
		//       edr: "edr",
		//     },
		//     {
		//       field: "vacationPayAccured",
		//       headerName: "Vac Due",
		//       description: "",
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       type: "text",
		//       align: "right",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       isEditable: true,
		//       sequence: 4,
		//       frozenColumn: false,
		//       footer: "100.00",
		//       minWidth: null,
		//       maxWidth: 120,
		//       fieldName: null,
		//       edr: "edr",
		//     },
		//     {
		//       field: "holidayHours",
		//       headerName: "Hol Hours",
		//       description: "",
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       type: "number",
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       isEditable: true,
		//       sequence: 4,
		//       frozenColumn: false,
		//       footer: "100.00",
		//       minWidth: null,
		//       maxWidth: 120,
		//       fieldName: null,
		//       edr: "edr",
		//     },
		//     {
		//       field: "holidayPayAccured",
		//       headerName: "Hol Pay Due",
		//       description: "",
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       type: "number",
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       isEditable: true,
		//       sequence: 4,
		//       frozenColumn: false,
		//       footer: "100.00",
		//       minWidth: null,
		//       maxWidth: 120,
		//       fieldName: null,
		//       edr: "edr",
		//     },
		//     {
		//       field: "holidayPay",
		//       headerName: "Hol Pay",
		//       description: "",
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       type: "number",
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       isEditable: true,
		//       sequence: 4,
		//       frozenColumn: false,
		//       footer: "100.00",
		//       minWidth: null,
		//       maxWidth: 120,
		//       fieldName: null,
		//       edr: "edr",
		//     },
		//     {
		//       field: "bonus",
		//       headerName: "Bonus",
		//       description: "",
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       type: "number",
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       isEditable: true,
		//       sequence: 4,
		//       frozenColumn: false,
		//       footer: "100.00",
		//       minWidth: null,
		//       maxWidth: 120,
		//       fieldName: null,
		//       edr: "edr",
		//     },
		//     {
		//       field: "nonPeriodicPayment",
		//       headerName: "NPP",
		//       description: "Non-Periodic Payment",
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       type: "number",
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       isEditable: true,
		//       sequence: 4,
		//       frozenColumn: false,
		//       footer: "100.00",
		//       minWidth: null,
		//       maxWidth: 120,
		//       fieldName: null,
		//       edr: "edr",
		//     },
		//     {
		//       field: "retroactivePayIncrease",
		//       headerName: "Retro Pay",
		//       description: "Retroactive Pay Increase",
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       type: "number",
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       isEditable: true,
		//       sequence: 4,
		//       frozenColumn: false,
		//       footer: "100.00",
		//       minWidth: null,
		//       maxWidth: 120,
		//       fieldName: null,
		//       edr: "edr",
		//     },
		//     {
		//       field: "earning",
		//       headerName: "earning",
		//       description: "",
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       type: "number",
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       isEditable: true,
		//       sequence: 4,
		//       frozenColumn: false,
		//       footer: "100.00",
		//       minWidth: null,
		//       maxWidth: 120,
		//       fieldName: null,
		//       edr: "earnings",
		//     },
		//   ],
		// };
		// return new Promise((resolve) =>
		//   setTimeout(() => resolve(fixedResponse), 1000)
		// );

		// const fixedResponse: any = {
		//   page: 1,
		//   size: 50,
		//   total: 2,
		//   items: [
		//     {
		//       employeeId: "254654351351365463436413541",
		//       id: "12",
		//       name: "Zeeshan Malik",
		//       gross: "100.00",
		//       regularHours: null,
		//       vacationPay: null,
		//       total: "100.00",
		//     },
		//     {
		//       employeeId: "254654351351365463436413541",
		//       id: "123",
		//       name: "Zeeshan Malik",
		//       gross: "100.00",
		//       regularHours: null,
		//       vacationPay: null,
		//       total: "100.00",
		//     },
		//   ],
		//   headerColumns: [
		//     {
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       maxWidth: 50,

		//       field: "id",
		//       headerName: "ID",
		//       description: "",
		//       type: "text",
		//       frozenColumn: true,
		//       sortable: false,
		//       isEditable: false,
		//       sequence: 0,
		//       footer: null,
		//     },
		//     {
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       maxWidth: 150,

		//       field: "name",
		//       headerName: "Name",
		//       description: "",
		//       type: "text",
		//       frozenColumn: true,
		//       sortable: false,
		//       isEditable: false,
		//       sequence: 1,
		//       footer: "Total",
		//     },
		//     {
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       maxWidth: 120,

		//       field: "gross",
		//       headerName: "Gross",
		//       description: "",
		//       type: "number",
		//       frozenColumn: false,
		//       sortable: false,
		//       isEditable: true,
		//       sequence: 2,
		//       footer: "100.00",
		//     },
		//     {
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       maxWidth: 120,

		//       field: "regularHours",
		//       headerName: "Reg. Hours",
		//       description: "",
		//       type: "number",
		//       frozenColumn: false,
		//       sortable: false,
		//       isEditable: true,
		//       sequence: 3,
		//       footer: "0.00",
		//     },
		//     {
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       maxWidth: 120,

		//       field: "ot1Dot5Hours",
		//       headerName: "OT 1.5",
		//       description: "",
		//       type: "number",
		//       frozenColumn: false,
		//       sortable: false,
		//       isEditable: true,
		//       sequence: 3,
		//       footer: "0.00",
		//     },
		//     {
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       maxWidth: 120,

		//       field: "ot2Dot0Hours",
		//       headerName: "OT 2.0",
		//       description: "",
		//       type: "number",
		//       frozenColumn: false,
		//       sortable: false,
		//       isEditable: true,
		//       sequence: 3,
		//       footer: "0.00",
		//     },
		//     {
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       maxWidth: 150,

		//       field: "total",
		//       headerName: "Total",
		//       description: "",
		//       type: "text",
		//       frozenColumn: false,
		//       sortable: false,
		//       isEditable: false,
		//       sequence: 4,
		//       footer: "100.00",
		//     },
		//     {
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       maxWidth: 120,

		//       field: "vacationDue",
		//       headerName: "Vac Due",
		//       description: "",
		//       type: "text",
		//       frozenColumn: false,
		//       sortable: false,
		//       isEditable: true,
		//       sequence: 5,
		//       footer: null,
		//     },
		//     {
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       maxWidth: 120,

		//       field: "vacationPay",
		//       headerName: "Vac Pay",
		//       description: "",
		//       type: "number",
		//       frozenColumn: false,
		//       sortable: false,
		//       isEditable: true,
		//       sequence: 5,
		//       footer: null,
		//     },
		//     {
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       maxWidth: 120,

		//       field: "holidayHours",
		//       headerName: "Hol Hours",
		//       description: "",
		//       type: "number",
		//       frozenColumn: false,
		//       sortable: false,
		//       isEditable: true,
		//       sequence: 6,
		//       footer: null,
		//     },
		//     {
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       maxWidth: 120,

		//       field: "holidayPayDue",
		//       headerName: "Hol Pay Due",
		//       description: "",
		//       type: "text",
		//       frozenColumn: false,
		//       sortable: false,
		//       isEditable: true,
		//       sequence: 6,
		//       footer: null,
		//     },
		//     {
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       maxWidth: 120,

		//       field: "holidayPay",
		//       headerName: "Hol Pay",
		//       description: "",
		//       type: "number",
		//       frozenColumn: false,
		//       sortable: false,
		//       isEditable: true,
		//       sequence: 6,
		//       footer: null,
		//     },
		//     {
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       maxWidth: 120,

		//       field: "bonus",
		//       headerName: "Bonus",
		//       description: "",
		//       type: "number",
		//       frozenColumn: false,
		//       sortable: false,
		//       isEditable: true,
		//       sequence: 6,
		//       footer: null,
		//     },
		//     {
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       maxWidth: 120,

		//       field: "nonPeriodicPayment",
		//       headerName: "Non-Periodic Payment",
		//       description: "",
		//       type: "number",
		//       frozenColumn: false,
		//       sortable: false,
		//       isEditable: true,
		//       sequence: 6,
		//       footer: null,
		//     },
		//     {
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       maxWidth: 120,

		//       field: "retroactivePayIncrease",
		//       headerName: "Retroactive Pay Increase",
		//       description: "",
		//       type: "number",
		//       frozenColumn: false,
		//       sortable: false,
		//       isEditable: true,
		//       sequence: 6,
		//       footer: null,
		//     },
		//     {
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       maxWidth: 120,

		//       field: "commission",
		//       headerName: "Commission",
		//       description: "",
		//       type: "number",
		//       frozenColumn: false,
		//       sortable: false,
		//       isEditable: true,
		//       sequence: 6,
		//       footer: null,
		//     },
		//     {
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       maxWidth: 120,

		//       field: "earnings",
		//       headerName: "Earnings 1",
		//       description: "",
		//       type: "number",
		//       frozenColumn: false,
		//       sortable: false,
		//       isEditable: true,
		//       sequence: 7,
		//       footer: null,

		//       edr: "earnings",
		//     },
		//     {
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       maxWidth: 120,

		//       field: "deductions",
		//       headerName: "Ded",
		//       description: "",
		//       type: "number",
		//       frozenColumn: false,
		//       sortable: false,
		//       isEditable: true,
		//       sequence: 8,
		//       footer: null,

		//       edr: "deductions",
		//     },
		//     {
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       maxWidth: 120,

		//       field: "reimbursements",
		//       headerName: "Reimb",
		//       description: "",
		//       type: "number",
		//       frozenColumn: false,
		//       sortable: false,
		//       isEditable: true,
		//       sequence: 9,
		//       footer: null,

		//       edr: "reimbursements",
		//     },
		//     // {
		//     //   flex: 1,
		//     //   hide: false,
		//     //   hideable: false,
		//     //   sortingOrder: "asc",
		//     //   resizable: false,
		//     //   align: "left",
		//     //   headerAlign: "left",
		//     //   hideSortIcons: false,
		//     //   disableColumnMenu: true,
		//     //   disableReorder: true,
		//     //   disableExport: true,
		//     //   maskable: false,
		//     //   isFixed: true,
		//     //   // maxWidth:120,

		//     //   field: "string",
		//     //   headerName: "",
		//     //   description: "",
		//     //   type: "string",
		//     //   frozenColumn: false,
		//     //   sortable: false,
		//     //   isEditable: false,
		//     //   sequence: 6,
		//     //   footer: null,
		//     // },
		//   ],
		// };
		// return new Promise((resolve) =>
		//   setTimeout(() => resolve(fixedResponse), 1000)
		// );
	},
	getRollBackPayroll: async (
		clientId: string,
		payPeriodFrequencyId: string | null,
		payPeriodStarDate: string | null,
		payPeriodEndDate: string | null,
		name: string,
		startsWith: string,
		department: string,
		paidBy: string,
		pageSize: number,
		page: number,
		data: IGetListRequest,
		navigateToLogout: (path: string) => void,
		openRollbackDialogue: boolean,
	): Promise<
		IPayrollListPayload | IServerError | IResponse | IPayrollResponse[] | null
	> => {
		if (
			payPeriodFrequencyId &&
			payPeriodStarDate &&
			payPeriodEndDate &&
			openRollbackDialogue
		) {
			try {
				const response: AxiosResponse<IPayrollListPayload> =
					await http.get<IPayrollListPayload>(
						`/v1/employee-payroll-data/get-list-without-calculated-data/for/roll-back/` +
							clientId +
							`/?pay_period_frequency_id=` +
							payPeriodFrequencyId +
							"&pay_period_star_date=" +
							payPeriodStarDate +
							"&pay_period_end_date=" +
							payPeriodEndDate +
							"&search_query=" +
							data.search_query +
							"&order_by=" +
							name +
							"&order_direction=" +
							data.order_direction +
							"&starts_with=" +
							startsWith +
							"&department=" +
							department +
							"&paid_by=" +
							paidBy +
							"&page=" +
							page +
							"&size=" +
							pageSize,
					);
				if (response.status === 200) {
					return response.data;
				} else if (response.status === 201) {
					return response.data;
				} else if (response.status === 400) {
					return {
						status: false,
						message: "Bad Request.",
						error: true,
					};
				} else if (response.status === 500) {
					return {
						status: false,
						message: "Something went wrong.",
						error: true,
					};
				}
				return {
					status: false,
					message: "Something went wrong please try again later.",
				};
			} catch (error) {
				const axiosError = error as AxiosError;
				console.error("An error occurred:", axiosError);
				const errorMessage =
					axiosError.response && typeof axiosError.response.data === "string"
						? axiosError.response.data
						: "Unknown error";
				if (axiosError && axiosError.status === 401) {
					navigateToLogout("/logout");
					return {
						status: false,
						message: "UnAuthrized",
					};
				} else {
					return {
						status: false,
						message: errorMessage,
					};
				}
			}
		}
		return null;
	},

	getCalculatedPayroll: async (
		clientId: string,
		payPeriodFrequencyId: string | null,
		payPeriodStarDate: string | null,
		payPeriodEndDate: string | null,
		viewCalculated: number | string,
		nameCalculated: string,
		startsWithCalculated: string,
		departmentCalculated: string,
		pageSizeCalculated: number,
		pageCalculated: number,
		data: IGetListRequest,
		navigateToLogout: (path: string) => void,
	): Promise<
		IPayrollListPayload | IServerError | IResponse | IPayrollResponse[] | any
	> => {
		if (payPeriodFrequencyId && payPeriodStarDate && payPeriodEndDate) {
			try {
				const response: AxiosResponse<IPayrollListPayload> =
					await http.get<IPayrollListPayload>(
						// "/v1/employee-payroll-data/get-list-for-caculated-payroll-data/" +
						// 	clientId +
						// 	"?pay_period_frequency_id=" +
						// 	payPeriodFrequencyId +
						// 	"&pay_period_star_date=" +
						// 	payPeriodStarDate +
						// 	"&pay_period_end_date=" +
						// 	payPeriodEndDate +
						// 	"&search_query=" +
						// 	data.search_query +
						// 	"&order_by=" +
						// 	data.order_by +
						// 	"&order_direction=" +
						// 	data.order_direction +
						// 	"&page=" +
						// 	data.page +
						// 	"&size=" +
						// 	data.size,
						`/v1/employee-payroll-data/get-list-for-caculated-payroll-data/` +
							clientId +
							"?pay_period_frequency_id=" +
							payPeriodFrequencyId +
							"&pay_period_star_date=" +
							payPeriodStarDate +
							"&pay_period_end_date=" +
							payPeriodEndDate +
							"&view=" +
							viewCalculated +
							"&search_query=" +
							data.search_query +
							"&order_by=" +
							nameCalculated +
							"&order_direction=" +
							data.order_direction +
							"&starts_with=" +
							startsWithCalculated +
							"&department=" +
							departmentCalculated +
							"&page=" +
							pageCalculated +
							"&size=" +
							pageSizeCalculated,
					);
				if (response.status === 200) {
					return response.data;
				} else if (response.status === 201) {
					return response.data;
				} else if (response.status === 400) {
					return {
						status: false,
						message: "Bad Request.",
						error: true,
					};
				} else if (response.status === 500) {
					return {
						status: false,
						message: "Something went wrong.",
						error: true,
					};
				}
				return {
					status: false,
					message: "Something went wrong please try again later.",
				};
			} catch (error) {
				const axiosError = error as AxiosError;
				console.error("An error occurred:", axiosError);
				const errorMessage =
					axiosError.response && typeof axiosError.response.data === "string"
						? axiosError.response.data
						: "Unknown error";
				if (axiosError && axiosError.status === 401) {
					navigateToLogout("/logout");
					return {
						status: false,
						message: "UnAuthrized",
					};
				} else {
					return {
						status: false,
						message: errorMessage,
					};
				}
			}
		}

		return null;

		// const fixedResponse: any = {
		//   page: 1,
		//   size: 50,
		//   total: 2,
		//   items: [
		//     {
		//       employeeId: "254654351351365463436413541",
		//       id: "12",
		//       name: "Zeeshan Malik",
		//       gross: "100.00",
		//       regularHours: null,
		//       vacationPay: null,
		//       total: "100.00",
		//     },
		//     {
		//       employeeId: "254654351351365463436413541",
		//       id: "123",
		//       name: "Zeeshan Malik",
		//       gross: "100.00",
		//       regularHours: null,
		//       vacationPay: null,
		//       total: "100.00",
		//     },
		//   ],
		//   headerColumns: [
		//     {
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       maxWidth: 50,

		//       field: "id",
		//       headerName: "ID",
		//       description: "",
		//       type: "text",
		//       frozenColumn: true,
		//       sortable: false,
		//       isEditable: false,
		//       sequence: 0,
		//       footer: null,
		//     },
		//     {
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       maxWidth: 150,

		//       field: "name",
		//       headerName: "Name",
		//       description: "",
		//       type: "text",
		//       frozenColumn: true,
		//       sortable: false,
		//       isEditable: false,
		//       sequence: 1,
		//       footer: "Total",
		//     },
		//     {
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       maxWidth: 120,

		//       field: "gross",
		//       headerName: "Gross",
		//       description: "",
		//       type: "number",
		//       frozenColumn: false,
		//       sortable: false,
		//       isEditable: true,
		//       sequence: 2,
		//       footer: "100.00",
		//     },
		//     {
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       maxWidth: 120,

		//       field: "regularHours",
		//       headerName: "Reg. Hours",
		//       description: "",
		//       type: "number",
		//       frozenColumn: false,
		//       sortable: false,
		//       isEditable: true,
		//       sequence: 3,
		//       footer: "0.00",
		//     },
		//     {
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       maxWidth: 120,

		//       field: "ot1Dot5Hours",
		//       headerName: "OT 1.5",
		//       description: "",
		//       type: "number",
		//       frozenColumn: false,
		//       sortable: false,
		//       isEditable: true,
		//       sequence: 3,
		//       footer: "0.00",
		//     },
		//     {
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       maxWidth: 120,

		//       field: "ot2Dot0Hours",
		//       headerName: "OT 2.0",
		//       description: "",
		//       type: "number",
		//       frozenColumn: false,
		//       sortable: false,
		//       isEditable: true,
		//       sequence: 3,
		//       footer: "0.00",
		//     },
		//     {
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       maxWidth: 150,

		//       field: "total",
		//       headerName: "Total",
		//       description: "",
		//       type: "text",
		//       frozenColumn: false,
		//       sortable: false,
		//       isEditable: false,
		//       sequence: 4,
		//       footer: "100.00",
		//     },
		//     {
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       maxWidth: 120,

		//       field: "vacationDue",
		//       headerName: "Vac Due",
		//       description: "",
		//       type: "text",
		//       frozenColumn: false,
		//       sortable: false,
		//       isEditable: true,
		//       sequence: 5,
		//       footer: null,
		//     },
		//     {
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       maxWidth: 120,

		//       field: "vacationPay",
		//       headerName: "Vac Pay",
		//       description: "",
		//       type: "number",
		//       frozenColumn: false,
		//       sortable: false,
		//       isEditable: true,
		//       sequence: 5,
		//       footer: null,
		//     },
		//     {
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       maxWidth: 120,

		//       field: "holidayHours",
		//       headerName: "Hol Hours",
		//       description: "",
		//       type: "number",
		//       frozenColumn: false,
		//       sortable: false,
		//       isEditable: true,
		//       sequence: 6,
		//       footer: null,
		//     },
		//     {
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       maxWidth: 120,

		//       field: "holidayPayDue",
		//       headerName: "Hol Pay Due",
		//       description: "",
		//       type: "text",
		//       frozenColumn: false,
		//       sortable: false,
		//       isEditable: true,
		//       sequence: 6,
		//       footer: null,
		//     },
		//     {
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       maxWidth: 120,

		//       field: "holidayPay",
		//       headerName: "Hol Pay",
		//       description: "",
		//       type: "number",
		//       frozenColumn: false,
		//       sortable: false,
		//       isEditable: true,
		//       sequence: 6,
		//       footer: null,
		//     },
		//     {
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       maxWidth: 120,

		//       field: "bonus",
		//       headerName: "Bonus",
		//       description: "",
		//       type: "number",
		//       frozenColumn: false,
		//       sortable: false,
		//       isEditable: true,
		//       sequence: 6,
		//       footer: null,
		//     },
		//     {
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       maxWidth: 120,

		//       field: "nonPeriodicPayment",
		//       headerName: "Non-Periodic Payment",
		//       description: "",
		//       type: "number",
		//       frozenColumn: false,
		//       sortable: false,
		//       isEditable: true,
		//       sequence: 6,
		//       footer: null,
		//     },
		//     {
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       maxWidth: 120,

		//       field: "retroactivePayIncrease",
		//       headerName: "Retroactive Pay Increase",
		//       description: "",
		//       type: "number",
		//       frozenColumn: false,
		//       sortable: false,
		//       isEditable: true,
		//       sequence: 6,
		//       footer: null,
		//     },
		//     {
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       maxWidth: 120,

		//       field: "commission",
		//       headerName: "Commission",
		//       description: "",
		//       type: "number",
		//       frozenColumn: false,
		//       sortable: false,
		//       isEditable: true,
		//       sequence: 6,
		//       footer: null,
		//     },
		//     {
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       maxWidth: 120,

		//       field: "earnings",
		//       headerName: "Earnings 1",
		//       description: "",
		//       type: "number",
		//       frozenColumn: false,
		//       sortable: false,
		//       isEditable: true,
		//       sequence: 7,
		//       footer: null,

		//       edr: "earnings",
		//     },
		//     {
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       maxWidth: 120,

		//       field: "deductions",
		//       headerName: "Ded",
		//       description: "",
		//       type: "number",
		//       frozenColumn: false,
		//       sortable: false,
		//       isEditable: true,
		//       sequence: 8,
		//       footer: null,

		//       edr: "deductions",
		//     },
		//     {
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       maxWidth: 120,

		//       field: "reimbursements",
		//       headerName: "Reimb",
		//       description: "",
		//       type: "number",
		//       frozenColumn: false,
		//       sortable: false,
		//       isEditable: true,
		//       sequence: 9,
		//       footer: null,

		//       edr: "reimbursements",
		//     },
		//     // {
		//     //   flex: 1,
		//     //   hide: false,
		//     //   hideable: false,
		//     //   sortingOrder: "asc",
		//     //   resizable: false,
		//     //   align: "left",
		//     //   headerAlign: "left",
		//     //   hideSortIcons: false,
		//     //   disableColumnMenu: true,
		//     //   disableReorder: true,
		//     //   disableExport: true,
		//     //   maskable: false,
		//     //   isFixed: true,
		//     //   // maxWidth:120,

		//     //   field: "string",
		//     //   headerName: "",
		//     //   description: "",
		//     //   type: "string",
		//     //   frozenColumn: false,
		//     //   sortable: false,
		//     //   isEditable: false,
		//     //   sequence: 6,
		//     //   footer: null,
		//     // },
		//   ],
		// };
		// return new Promise((resolve) =>
		//   setTimeout(() => resolve(fixedResponse), 1000)
		// );
	},
	getCalculatedPayrollRollBack: async (
		clientId: string,
		payPeriodFrequencyId: string | null,
		payPeriodStarDate: string | null,
		payPeriodEndDate: string | null,
		viewCalculated: number | string,
		nameCalculated: string,
		startsWithCalculated: string,
		departmentCalculated: string,
		pageSizeCalculated: number,
		pageCalculated: number,
		data: IGetListRequest,
		navigateToLogout: (path: string) => void,
		openRollbackDialogue: boolean,
	): Promise<
		IPayrollListPayload | IServerError | IResponse | IPayrollResponse[] | any
	> => {
		if (
			payPeriodFrequencyId &&
			payPeriodStarDate &&
			payPeriodEndDate &&
			openRollbackDialogue
		) {
			try {
				const response: AxiosResponse<IPayrollListPayload> =
					await http.get<IPayrollListPayload>(
						`/v1/employee-payroll-data/get-list-for-roll-back/employee/` +
							clientId +
							"?pay_period_frequency_id=" +
							payPeriodFrequencyId +
							"&pay_period_star_date=" +
							payPeriodStarDate +
							"&pay_period_end_date=" +
							payPeriodEndDate +
							"&view=" +
							viewCalculated +
							"&search_query=" +
							data.search_query +
							"&order_by=" +
							nameCalculated +
							"&order_direction=" +
							data.order_direction +
							"&starts_with=" +
							startsWithCalculated +
							"&department=" +
							departmentCalculated +
							"&page=" +
							pageCalculated +
							"&size=" +
							pageSizeCalculated,
					);
				if (response.status === 200) {
					return response.data;
				} else if (response.status === 201) {
					return response.data;
				} else if (response.status === 400) {
					return {
						status: false,
						message: "Bad Request.",
						error: true,
					};
				} else if (response.status === 500) {
					return {
						status: false,
						message: "Something went wrong.",
						error: true,
					};
				}
				return {
					status: false,
					message: "Something went wrong please try again later.",
				};
			} catch (error) {
				const axiosError = error as AxiosError;
				console.error("An error occurred:", axiosError);
				const errorMessage =
					axiosError.response && typeof axiosError.response.data === "string"
						? axiosError.response.data
						: "Unknown error";
				if (axiosError && axiosError.status === 401) {
					navigateToLogout("/logout");
					return {
						status: false,
						message: "UnAuthrized",
					};
				} else {
					return {
						status: false,
						message: errorMessage,
					};
				}
			}
		}
		return null;
	},
	getPayrollAdjustment: async (
		clientId: string,
		payPeriodFrequencyId: string | null,
		payPeriodStarDate: string | null,
		payPeriodEndDate: string | null,
		data: IGetListRequest,
		navigateToLogout: (path: string) => void,
	): Promise<
		IPayrollListPayload | IServerError | IResponse | IPayrollResponse[] | null
	> => {
		if (payPeriodFrequencyId && payPeriodStarDate && payPeriodEndDate) {
			try {
				const response: AxiosResponse<IPayrollListPayload> =
					await http.get<IPayrollListPayload>(
						"/v1/employee-payroll-adjustments/?client_id=" +
							clientId +
							"&pay_period_frequency_id=" +
							payPeriodFrequencyId +
							"&pay_period_star_date=" +
							payPeriodStarDate +
							"&pay_period_end_date=" +
							payPeriodEndDate +
							"&search_query=" +
							data.search_query +
							"&order_by=" +
							data.order_by +
							"&order_direction=" +
							data.order_direction +
							"&page=" +
							data.page +
							"&size=" +
							data.size,
					);
				if (response.status === 200) {
					return response.data;
				} else if (response.status === 201) {
					return response.data;
				} else if (response.status === 400) {
					return {
						status: false,
						message: "Bad Request.",
						error: true,
					};
				} else if (response.status === 500) {
					return {
						status: false,
						message: "Something went wrong.",
						error: true,
					};
				}
				return {
					status: false,
					message: "Something went wrong please try again later.",
				};
			} catch (error) {
				const axiosError = error as AxiosError;
				console.error("An error occurred:", axiosError);
				const errorMessage =
					axiosError.response && typeof axiosError.response.data === "string"
						? axiosError.response.data
						: "Unknown error";
				if (axiosError && axiosError.status === 401) {
					navigateToLogout("/logout");
					return {
						status: false,
						message: "UnAuthrized",
					};
				} else {
					return {
						status: false,
						message: errorMessage,
					};
				}
			}
		}

		return null;

		// const fixedResponse: any = {
		//   page: 1,
		//   size: 25,
		//   rowSelection: true,
		//   total: 1,
		//   items: [
		//     {
		//       employeeName: "Tipu Sultan",
		//       employeeNumberId: "",
		//       provinceId: "67bd7102b5278a5ae5018ca3",
		//       province: {
		//         id: "67bd7102b5278a5ae5018ca3",
		//         name: "Alberta",
		//         shortCode: "AB",
		//       },
		//       dateOfHire: "2025-01-01",
		//       payPeriod: 12,
		//       payMethod: 100,
		//       salaryProfileMessage: null,
		//       td1Prov: "Exist",
		//       td1Fed: "Exist",
		//       employeeId: "69425242f639c2c0be9b2aa4",
		//       cppQppExempt: true,
		//       eiExempt: true,
		//       qpipExempt: false,
		//       federalTaxExempt: false,
		//       provisionalTaxExempt: false,
		//       hourlyRate: 2.2222222222222223,
		//       regularHoursData: 4.5,
		//       erdEarning: [],
		//       erdReimbursement: [],
		//       erdDeduction: [],
		//       commission: 0.0,
		//       retroactivePayIncrease: 0.0,
		//       nonPeriodicPayment: 0.0,
		//       bonus: 0.0,
		//       holidayPay: 0.0,
		//       holidayPayAccured: 0.0,
		//       vacationPay: 0.0,
		//       ot2Dot0Hours: null,
		//       ot1Dot5Hours: null,
		//       grossIncome: 199.0,
		//       regularHours: null,
		//       vacationPayAccured: 7.96,
		//       holidayHours: 0.0,
		//       isPayrollCalculated: false,

		//       hourlyPayRate: 4.4,
		//       vocationable: [
		//         "regularGross",
		//         "regularHours",
		//         "vacationPay",
		//         "commission",
		//         "ot1Dot5Hours",
		//         "ot2Dot0Hours",
		//         "grossIncome",
		//         "earning",
		//       ],
		//     },
		//   ],
		//   keyField: {
		//     field: "id",
		//     templateUrl: "/payroll/setup/id",
		//   },
		//   headerColumns: [
		//     {
		//       field: "employeeNumberId",
		//       headerName: "ID",
		//       description: "",
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       type: "text",
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       isEditable: false,
		//       sequence: 0,
		//       frozenColumn: true,
		//       footer: null,
		//       minWidth: null,
		//       maxWidth: 50,
		//       fieldName: null,
		//       edr: "edr",
		//     },
		//     {
		//       field: "employeeName",
		//       headerName: "Name",
		//       description: "",
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       type: "text",
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       isEditable: false,
		//       sequence: 1,
		//       frozenColumn: true,
		//       footer: "Total",
		//       minWidth: null,
		//       maxWidth: 150,
		//       fieldName: null,
		//       edr: "edr",
		//     },
		//     {
		//       field: "grossIncome",
		//       headerName: "Gross",
		//       description: "",
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       type: "number",
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       isEditable: true,
		//       sequence: 2,
		//       frozenColumn: false,
		//       footer: "100.00",
		//       minWidth: null,
		//       maxWidth: 120,
		//       fieldName: null,
		//       edr: "edr",
		//     },
		//     {
		//       field: "regularHours",
		//       headerName: "Reg. Hours",
		//       description: "",
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       type: "number",
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       isEditable: true,
		//       sequence: 3,
		//       frozenColumn: false,
		//       footer: "0.00",
		//       minWidth: null,
		//       maxWidth: 120,
		//       fieldName: null,
		//       edr: "edr",
		//     },
		//     {
		//       field: "ot1Dot5Hours",
		//       headerName: "OT 1.5",
		//       description: "",
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       type: "number",
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       isEditable: true,
		//       sequence: 4,
		//       frozenColumn: false,
		//       footer: "100.00",
		//       minWidth: null,
		//       maxWidth: 120,
		//       fieldName: null,
		//       edr: "edr",
		//     },
		//     {
		//       field: "ot2Dot0Hours",
		//       headerName: "OT 2.0",
		//       description: "",
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       type: "number",
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       isEditable: true,
		//       sequence: 4,
		//       frozenColumn: false,
		//       footer: "100.00",
		//       minWidth: null,
		//       maxWidth: 120,
		//       fieldName: null,
		//       edr: "edr",
		//     },
		//     {
		//       field: "total",
		//       headerName: "Total",
		//       description: "",
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       type: "text",
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       isEditable: false,
		//       sequence: 4,
		//       frozenColumn: false,
		//       footer: "100.00",
		//       minWidth: null,
		//       maxWidth: 150,
		//       fieldName: null,
		//       edr: "edr",
		//     },
		//     {
		//       field: "vacationPay",
		//       headerName: "Vacation Pay",
		//       description: "",
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       type: "number",
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       isEditable: true,
		//       sequence: 4,
		//       frozenColumn: false,
		//       footer: "100.00",
		//       minWidth: null,
		//       maxWidth: 120,
		//       fieldName: null,
		//       edr: "edr",
		//     },
		//     {
		//       field: "vacationPayAccured",
		//       headerName: "Vac Due",
		//       description: "",
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       type: "text",
		//       align: "right",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       isEditable: true,
		//       sequence: 4,
		//       frozenColumn: false,
		//       footer: "100.00",
		//       minWidth: null,
		//       maxWidth: 120,
		//       fieldName: null,
		//       edr: "edr",
		//     },
		//     {
		//       field: "holidayHours",
		//       headerName: "Hol Hours",
		//       description: "",
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       type: "number",
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       isEditable: true,
		//       sequence: 4,
		//       frozenColumn: false,
		//       footer: "100.00",
		//       minWidth: null,
		//       maxWidth: 120,
		//       fieldName: null,
		//       edr: "edr",
		//     },
		//     {
		//       field: "holidayPayAccured",
		//       headerName: "Hol Pay Due",
		//       description: "",
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       type: "number",
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       isEditable: true,
		//       sequence: 4,
		//       frozenColumn: false,
		//       footer: "100.00",
		//       minWidth: null,
		//       maxWidth: 120,
		//       fieldName: null,
		//       edr: "edr",
		//     },
		//     {
		//       field: "holidayPay",
		//       headerName: "Hol Pay",
		//       description: "",
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       type: "number",
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       isEditable: true,
		//       sequence: 4,
		//       frozenColumn: false,
		//       footer: "100.00",
		//       minWidth: null,
		//       maxWidth: 120,
		//       fieldName: null,
		//       edr: "edr",
		//     },
		//     {
		//       field: "bonus",
		//       headerName: "Bonus",
		//       description: "",
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       type: "number",
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       isEditable: true,
		//       sequence: 4,
		//       frozenColumn: false,
		//       footer: "100.00",
		//       minWidth: null,
		//       maxWidth: 120,
		//       fieldName: null,
		//       edr: "edr",
		//     },
		//     {
		//       field: "nonPeriodicPayment",
		//       headerName: "NPP",
		//       description: "Non-Periodic Payment",
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       type: "number",
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       isEditable: true,
		//       sequence: 4,
		//       frozenColumn: false,
		//       footer: "100.00",
		//       minWidth: null,
		//       maxWidth: 120,
		//       fieldName: null,
		//       edr: "edr",
		//     },
		//     {
		//       field: "retroactivePayIncrease",
		//       headerName: "Retro Pay",
		//       description: "Retroactive Pay Increase",
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       type: "number",
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       isEditable: true,
		//       sequence: 4,
		//       frozenColumn: false,
		//       footer: "100.00",
		//       minWidth: null,
		//       maxWidth: 120,
		//       fieldName: null,
		//       edr: "edr",
		//     },
		//     {
		//       field: "earning",
		//       headerName: "earning",
		//       description: "",
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       type: "number",
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       isEditable: true,
		//       sequence: 4,
		//       frozenColumn: false,
		//       footer: "100.00",
		//       minWidth: null,
		//       maxWidth: 120,
		//       fieldName: null,
		//       edr: "earnings",
		//     },
		//   ],
		// };
		// return new Promise((resolve) =>
		//   setTimeout(() => resolve(fixedResponse), 1000)
		// );

		// const fixedResponse: any = {
		//   page: 1,
		//   size: 50,
		//   total: 2,
		//   items: [
		//     {
		//       employeeId: "254654351351365463436413541",
		//       id: "12",
		//       name: "Zeeshan Malik",
		//       gross: "100.00",
		//       regularHours: null,
		//       vacationPay: null,
		//       total: "100.00",
		//     },
		//     {
		//       employeeId: "254654351351365463436413541",
		//       id: "123",
		//       name: "Zeeshan Malik",
		//       gross: "100.00",
		//       regularHours: null,
		//       vacationPay: null,
		//       total: "100.00",
		//     },
		//   ],
		//   headerColumns: [
		//     {
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       maxWidth: 50,

		//       field: "id",
		//       headerName: "ID",
		//       description: "",
		//       type: "text",
		//       frozenColumn: true,
		//       sortable: false,
		//       isEditable: false,
		//       sequence: 0,
		//       footer: null,
		//     },
		//     {
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       maxWidth: 150,

		//       field: "name",
		//       headerName: "Name",
		//       description: "",
		//       type: "text",
		//       frozenColumn: true,
		//       sortable: false,
		//       isEditable: false,
		//       sequence: 1,
		//       footer: "Total",
		//     },
		//     {
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       maxWidth: 120,

		//       field: "gross",
		//       headerName: "Gross",
		//       description: "",
		//       type: "number",
		//       frozenColumn: false,
		//       sortable: false,
		//       isEditable: true,
		//       sequence: 2,
		//       footer: "100.00",
		//     },
		//     {
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       maxWidth: 120,

		//       field: "regularHours",
		//       headerName: "Reg. Hours",
		//       description: "",
		//       type: "number",
		//       frozenColumn: false,
		//       sortable: false,
		//       isEditable: true,
		//       sequence: 3,
		//       footer: "0.00",
		//     },
		//     {
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       maxWidth: 120,

		//       field: "ot1Dot5Hours",
		//       headerName: "OT 1.5",
		//       description: "",
		//       type: "number",
		//       frozenColumn: false,
		//       sortable: false,
		//       isEditable: true,
		//       sequence: 3,
		//       footer: "0.00",
		//     },
		//     {
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       maxWidth: 120,

		//       field: "ot2Dot0Hours",
		//       headerName: "OT 2.0",
		//       description: "",
		//       type: "number",
		//       frozenColumn: false,
		//       sortable: false,
		//       isEditable: true,
		//       sequence: 3,
		//       footer: "0.00",
		//     },
		//     {
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       maxWidth: 150,

		//       field: "total",
		//       headerName: "Total",
		//       description: "",
		//       type: "text",
		//       frozenColumn: false,
		//       sortable: false,
		//       isEditable: false,
		//       sequence: 4,
		//       footer: "100.00",
		//     },
		//     {
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       maxWidth: 120,

		//       field: "vacationDue",
		//       headerName: "Vac Due",
		//       description: "",
		//       type: "text",
		//       frozenColumn: false,
		//       sortable: false,
		//       isEditable: true,
		//       sequence: 5,
		//       footer: null,
		//     },
		//     {
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       maxWidth: 120,

		//       field: "vacationPay",
		//       headerName: "Vac Pay",
		//       description: "",
		//       type: "number",
		//       frozenColumn: false,
		//       sortable: false,
		//       isEditable: true,
		//       sequence: 5,
		//       footer: null,
		//     },
		//     {
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       maxWidth: 120,

		//       field: "holidayHours",
		//       headerName: "Hol Hours",
		//       description: "",
		//       type: "number",
		//       frozenColumn: false,
		//       sortable: false,
		//       isEditable: true,
		//       sequence: 6,
		//       footer: null,
		//     },
		//     {
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       maxWidth: 120,

		//       field: "holidayPayDue",
		//       headerName: "Hol Pay Due",
		//       description: "",
		//       type: "text",
		//       frozenColumn: false,
		//       sortable: false,
		//       isEditable: true,
		//       sequence: 6,
		//       footer: null,
		//     },
		//     {
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       maxWidth: 120,

		//       field: "holidayPay",
		//       headerName: "Hol Pay",
		//       description: "",
		//       type: "number",
		//       frozenColumn: false,
		//       sortable: false,
		//       isEditable: true,
		//       sequence: 6,
		//       footer: null,
		//     },
		//     {
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       maxWidth: 120,

		//       field: "bonus",
		//       headerName: "Bonus",
		//       description: "",
		//       type: "number",
		//       frozenColumn: false,
		//       sortable: false,
		//       isEditable: true,
		//       sequence: 6,
		//       footer: null,
		//     },
		//     {
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       maxWidth: 120,

		//       field: "nonPeriodicPayment",
		//       headerName: "Non-Periodic Payment",
		//       description: "",
		//       type: "number",
		//       frozenColumn: false,
		//       sortable: false,
		//       isEditable: true,
		//       sequence: 6,
		//       footer: null,
		//     },
		//     {
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       maxWidth: 120,

		//       field: "retroactivePayIncrease",
		//       headerName: "Retroactive Pay Increase",
		//       description: "",
		//       type: "number",
		//       frozenColumn: false,
		//       sortable: false,
		//       isEditable: true,
		//       sequence: 6,
		//       footer: null,
		//     },
		//     {
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       maxWidth: 120,

		//       field: "commission",
		//       headerName: "Commission",
		//       description: "",
		//       type: "number",
		//       frozenColumn: false,
		//       sortable: false,
		//       isEditable: true,
		//       sequence: 6,
		//       footer: null,
		//     },
		//     {
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       maxWidth: 120,

		//       field: "earnings",
		//       headerName: "Earnings 1",
		//       description: "",
		//       type: "number",
		//       frozenColumn: false,
		//       sortable: false,
		//       isEditable: true,
		//       sequence: 7,
		//       footer: null,

		//       edr: "earnings",
		//     },
		//     {
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       maxWidth: 120,

		//       field: "deductions",
		//       headerName: "Ded",
		//       description: "",
		//       type: "number",
		//       frozenColumn: false,
		//       sortable: false,
		//       isEditable: true,
		//       sequence: 8,
		//       footer: null,

		//       edr: "deductions",
		//     },
		//     {
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       maxWidth: 120,

		//       field: "reimbursements",
		//       headerName: "Reimb",
		//       description: "",
		//       type: "number",
		//       frozenColumn: false,
		//       sortable: false,
		//       isEditable: true,
		//       sequence: 9,
		//       footer: null,

		//       edr: "reimbursements",
		//     },
		//     // {
		//     //   flex: 1,
		//     //   hide: false,
		//     //   hideable: false,
		//     //   sortingOrder: "asc",
		//     //   resizable: false,
		//     //   align: "left",
		//     //   headerAlign: "left",
		//     //   hideSortIcons: false,
		//     //   disableColumnMenu: true,
		//     //   disableReorder: true,
		//     //   disableExport: true,
		//     //   maskable: false,
		//     //   isFixed: true,
		//     //   // maxWidth:120,

		//     //   field: "string",
		//     //   headerName: "",
		//     //   description: "",
		//     //   type: "string",
		//     //   frozenColumn: false,
		//     //   sortable: false,
		//     //   isEditable: false,
		//     //   sequence: 6,
		//     //   footer: null,
		//     // },
		//   ],
		// };
		// return new Promise((resolve) =>
		//   setTimeout(() => resolve(fixedResponse), 1000)
		// );
	},

	getCalculatedPayrollAdjustment: async (
		clientId: string,
		payPeriodFrequencyId: string | null,
		payPeriodStarDate: string | null,
		payPeriodEndDate: string | null,
		data: IGetListRequest,
		navigateToLogout: (path: string) => void,
	): Promise<
		IPayrollListPayload | IServerError | IResponse | IPayrollResponse[] | any
	> => {
		if (payPeriodFrequencyId && payPeriodStarDate && payPeriodEndDate) {
			try {
				const response: AxiosResponse<IPayrollListPayload> =
					await http.get<IPayrollListPayload>(
						"/v1/employee-payroll-adjustments/adjusted-caculated-payroll-data/" +
							clientId +
							"?pay_period_frequency_id=" +
							payPeriodFrequencyId +
							"&pay_period_star_date=" +
							payPeriodStarDate +
							"&pay_period_end_date=" +
							payPeriodEndDate +
							"&search_query=" +
							data.search_query +
							"&order_by=" +
							data.order_by +
							"&order_direction=" +
							data.order_direction +
							"&page=" +
							data.page +
							"&size=" +
							data.size,
					);
				if (response.status === 200) {
					return response.data;
				} else if (response.status === 201) {
					return response.data;
				} else if (response.status === 400) {
					return {
						status: false,
						message: "Bad Request.",
						error: true,
					};
				} else if (response.status === 500) {
					return {
						status: false,
						message: "Something went wrong.",
						error: true,
					};
				}
				return {
					status: false,
					message: "Something went wrong please try again later.",
				};
			} catch (error) {
				const axiosError = error as AxiosError;
				console.error("An error occurred:", axiosError);
				const errorMessage =
					axiosError.response && typeof axiosError.response.data === "string"
						? axiosError.response.data
						: "Unknown error";
				if (axiosError && axiosError.status === 401) {
					navigateToLogout("/logout");
					return {
						status: false,
						message: "UnAuthrized",
					};
				} else {
					return {
						status: false,
						message: errorMessage,
					};
				}
			}
		}

		return null;

		// const fixedResponse: any = {
		//   page: 1,
		//   size: 50,
		//   total: 2,
		//   items: [
		//     {
		//       employeeId: "254654351351365463436413541",
		//       id: "12",
		//       name: "Zeeshan Malik",
		//       gross: "100.00",
		//       regularHours: null,
		//       vacationPay: null,
		//       total: "100.00",
		//     },
		//     {
		//       employeeId: "254654351351365463436413541",
		//       id: "123",
		//       name: "Zeeshan Malik",
		//       gross: "100.00",
		//       regularHours: null,
		//       vacationPay: null,
		//       total: "100.00",
		//     },
		//   ],
		//   headerColumns: [
		//     {
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       maxWidth: 50,

		//       field: "id",
		//       headerName: "ID",
		//       description: "",
		//       type: "text",
		//       frozenColumn: true,
		//       sortable: false,
		//       isEditable: false,
		//       sequence: 0,
		//       footer: null,
		//     },
		//     {
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       maxWidth: 150,

		//       field: "name",
		//       headerName: "Name",
		//       description: "",
		//       type: "text",
		//       frozenColumn: true,
		//       sortable: false,
		//       isEditable: false,
		//       sequence: 1,
		//       footer: "Total",
		//     },
		//     {
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       maxWidth: 120,

		//       field: "gross",
		//       headerName: "Gross",
		//       description: "",
		//       type: "number",
		//       frozenColumn: false,
		//       sortable: false,
		//       isEditable: true,
		//       sequence: 2,
		//       footer: "100.00",
		//     },
		//     {
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       maxWidth: 120,

		//       field: "regularHours",
		//       headerName: "Reg. Hours",
		//       description: "",
		//       type: "number",
		//       frozenColumn: false,
		//       sortable: false,
		//       isEditable: true,
		//       sequence: 3,
		//       footer: "0.00",
		//     },
		//     {
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       maxWidth: 120,

		//       field: "ot1Dot5Hours",
		//       headerName: "OT 1.5",
		//       description: "",
		//       type: "number",
		//       frozenColumn: false,
		//       sortable: false,
		//       isEditable: true,
		//       sequence: 3,
		//       footer: "0.00",
		//     },
		//     {
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       maxWidth: 120,

		//       field: "ot2Dot0Hours",
		//       headerName: "OT 2.0",
		//       description: "",
		//       type: "number",
		//       frozenColumn: false,
		//       sortable: false,
		//       isEditable: true,
		//       sequence: 3,
		//       footer: "0.00",
		//     },
		//     {
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       maxWidth: 150,

		//       field: "total",
		//       headerName: "Total",
		//       description: "",
		//       type: "text",
		//       frozenColumn: false,
		//       sortable: false,
		//       isEditable: false,
		//       sequence: 4,
		//       footer: "100.00",
		//     },
		//     {
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       maxWidth: 120,

		//       field: "vacationDue",
		//       headerName: "Vac Due",
		//       description: "",
		//       type: "text",
		//       frozenColumn: false,
		//       sortable: false,
		//       isEditable: true,
		//       sequence: 5,
		//       footer: null,
		//     },
		//     {
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       maxWidth: 120,

		//       field: "vacationPay",
		//       headerName: "Vac Pay",
		//       description: "",
		//       type: "number",
		//       frozenColumn: false,
		//       sortable: false,
		//       isEditable: true,
		//       sequence: 5,
		//       footer: null,
		//     },
		//     {
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       maxWidth: 120,

		//       field: "holidayHours",
		//       headerName: "Hol Hours",
		//       description: "",
		//       type: "number",
		//       frozenColumn: false,
		//       sortable: false,
		//       isEditable: true,
		//       sequence: 6,
		//       footer: null,
		//     },
		//     {
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       maxWidth: 120,

		//       field: "holidayPayDue",
		//       headerName: "Hol Pay Due",
		//       description: "",
		//       type: "text",
		//       frozenColumn: false,
		//       sortable: false,
		//       isEditable: true,
		//       sequence: 6,
		//       footer: null,
		//     },
		//     {
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       maxWidth: 120,

		//       field: "holidayPay",
		//       headerName: "Hol Pay",
		//       description: "",
		//       type: "number",
		//       frozenColumn: false,
		//       sortable: false,
		//       isEditable: true,
		//       sequence: 6,
		//       footer: null,
		//     },
		//     {
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       maxWidth: 120,

		//       field: "bonus",
		//       headerName: "Bonus",
		//       description: "",
		//       type: "number",
		//       frozenColumn: false,
		//       sortable: false,
		//       isEditable: true,
		//       sequence: 6,
		//       footer: null,
		//     },
		//     {
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       maxWidth: 120,

		//       field: "nonPeriodicPayment",
		//       headerName: "Non-Periodic Payment",
		//       description: "",
		//       type: "number",
		//       frozenColumn: false,
		//       sortable: false,
		//       isEditable: true,
		//       sequence: 6,
		//       footer: null,
		//     },
		//     {
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       maxWidth: 120,

		//       field: "retroactivePayIncrease",
		//       headerName: "Retroactive Pay Increase",
		//       description: "",
		//       type: "number",
		//       frozenColumn: false,
		//       sortable: false,
		//       isEditable: true,
		//       sequence: 6,
		//       footer: null,
		//     },
		//     {
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       maxWidth: 120,

		//       field: "commission",
		//       headerName: "Commission",
		//       description: "",
		//       type: "number",
		//       frozenColumn: false,
		//       sortable: false,
		//       isEditable: true,
		//       sequence: 6,
		//       footer: null,
		//     },
		//     {
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       maxWidth: 120,

		//       field: "earnings",
		//       headerName: "Earnings 1",
		//       description: "",
		//       type: "number",
		//       frozenColumn: false,
		//       sortable: false,
		//       isEditable: true,
		//       sequence: 7,
		//       footer: null,

		//       edr: "earnings",
		//     },
		//     {
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       maxWidth: 120,

		//       field: "deductions",
		//       headerName: "Ded",
		//       description: "",
		//       type: "number",
		//       frozenColumn: false,
		//       sortable: false,
		//       isEditable: true,
		//       sequence: 8,
		//       footer: null,

		//       edr: "deductions",
		//     },
		//     {
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       maxWidth: 120,

		//       field: "reimbursements",
		//       headerName: "Reimb",
		//       description: "",
		//       type: "number",
		//       frozenColumn: false,
		//       sortable: false,
		//       isEditable: true,
		//       sequence: 9,
		//       footer: null,

		//       edr: "reimbursements",
		//     },
		//     // {
		//     //   flex: 1,
		//     //   hide: false,
		//     //   hideable: false,
		//     //   sortingOrder: "asc",
		//     //   resizable: false,
		//     //   align: "left",
		//     //   headerAlign: "left",
		//     //   hideSortIcons: false,
		//     //   disableColumnMenu: true,
		//     //   disableReorder: true,
		//     //   disableExport: true,
		//     //   maskable: false,
		//     //   isFixed: true,
		//     //   // maxWidth:120,

		//     //   field: "string",
		//     //   headerName: "",
		//     //   description: "",
		//     //   type: "string",
		//     //   frozenColumn: false,
		//     //   sortable: false,
		//     //   isEditable: false,
		//     //   sequence: 6,
		//     //   footer: null,
		//     // },
		//   ],
		// };
		// return new Promise((resolve) =>
		//   setTimeout(() => resolve(fixedResponse), 1000)
		// );
	},
	getPayrollSavedFrequency: async (
		clientId: string,
		taxYear: number,
		navigateToLogout: (path: string) => void,
	): Promise<
		IPayrollListPayload | IServerError | IResponse | IPayrollResponse[] | null
	> => {
		try {
			const response: AxiosResponse<IPayrollListPayload> =
				await http.get<IPayrollListPayload>(
					"/v1/payroll/" + clientId + "/?tax_year=" + taxYear,
				);

			if (response.status === 200) {
				return response.data;
			} else if (response.status === 201) {
				return response.data;
			} else if (response.status === 400) {
				return {
					status: false,
					message: "Bad Request.",
					error: true,
				};
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}
			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},

	create: async (
		requestPayload: any,
	): Promise<IPayroll | IServerError | IResponse | any> => {
		try {
			const response: AxiosResponse<IPayroll> = await http.post<IPayroll>(
				"/v1/employee-payroll-data/",
				requestPayload,
			);

			if (response.status === 201) {
				return response;
			} else if (response.status === 400) {
				return response.data;
			} else if (response.status === 401) {
				// window.location.href = '/logout';
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				requestPayload.navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else if (axiosError && axiosError.status === 422) {
				return {
					status: false,
					message: `Errors : \n${format422Errors(axiosError?.response?.data)}`,
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},
	payrollAdjustmentSaveData: async (
		requestPayload: any,
	): Promise<IPayroll | IServerError | IResponse | any> => {
		try {
			const response: AxiosResponse<IPayroll> = await http.post<IPayroll>(
				"/v1/employee-payroll-adjustments/save/data/",
				requestPayload,
			);

			if (response.status === 201) {
				return response;
			} else if (response.status === 400) {
				return response.data;
			} else if (response.status === 401) {
				// window.location.href = '/logout';
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				requestPayload.navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else if (axiosError && axiosError.status === 422) {
				return {
					status: false,
					message: `Errors : \n${format422Errors(axiosError?.response?.data)}`,
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},
	calculate: async (
		requestPayload: any,
	): Promise<IPayroll | IServerError | IResponse | any> => {
		try {
			const response: AxiosResponse<IPayroll> = await http.post<IPayroll>(
				"/v1/payroll-engine/",
				requestPayload.data,
			);

			if (response.status === 201) {
				return response;
			} else if (response.status === 400) {
				return response.data;
			} else if (response.status === 401) {
				// window.location.href = '/logout';
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				requestPayload.navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else if (axiosError && axiosError.status === 422) {
				return {
					status: false,
					message: `Errors : \n${format422Errors(axiosError?.response?.data)}`,
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},
	calculatePayrollAdjustment: async (
		requestPayload: any,
	): Promise<IPayroll | IServerError | IResponse | any> => {
		try {
			const response: AxiosResponse<IPayroll> = await http.post<IPayroll>(
				"/v1/payroll-adjustment-engine/",
				requestPayload.data,
			);

			if (response.status === 201) {
				return response;
			} else if (response.status === 400) {
				return response.data;
			} else if (response.status === 401) {
				// window.location.href = '/logout';
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				requestPayload.navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else if (axiosError && axiosError.status === 422) {
				return {
					status: false,
					message: `Errors : \n${format422Errors(axiosError?.response?.data)}`,
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},
	process: async (
		requestPayload: any,
	): Promise<IPayroll | IServerError | IResponse | any> => {
		try {
			const response: AxiosResponse<IPayroll> = await http.post<IPayroll>(
				`/v1/billing-calculation/?client_id=${requestPayload.payrollData.clientId}&payment_method=${requestPayload.payrollData.paymentMethod}&client_province=${requestPayload.payrollData.province}&tax_year=${requestPayload.payrollData.taxYear}&pay_period_end_date=${requestPayload.payrollData.payPeriodEndDate}&payroll_schedule_id=${requestPayload.payrollData.payPeriodFrequencyId}`,
				// requestPayload.data
			);

			if (response.status === 201) {
				return response;
			} else if (response.status === 400) {
				return response.data;
			} else if (response.status === 401) {
				// window.location.href = '/logout';
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				requestPayload.navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else if (axiosError && axiosError.status === 422) {
				return {
					status: false,
					message: `Errors : \n${format422Errors(axiosError?.response?.data)}`,
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},
	processRollBack: async (
		requestPayload: any,
	): Promise<IPayroll | IServerError | IResponse | any> => {
		try {
			const response: AxiosResponse<IPayroll> = await http.post<IPayroll>(
				`/v1/direct-deposit-roll-back/process-roll-back-data/?client_id=${requestPayload.clientId}&pay_period_frequency_id=${requestPayload.payPeriodFrequencyId}&pay_period_start_date=${requestPayload.payPeriodStarDate}&pay_period_end_date=${requestPayload.payPeriodEndDate}`,
				// requestPayload.data
			);

			if (response.status === 201) {
				return response;
			} else if (response.status === 400) {
				return response.data;
			} else if (response.status === 401) {
				// window.location.href = '/logout';
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				requestPayload.navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else if (axiosError && axiosError.status === 422) {
				return {
					status: false,
					message: `Errors : \n${format422Errors(axiosError?.response?.data)}`,
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},
	payrollAdjustmentPostEntry: async (
		requestPayload: any,
	): Promise<IPayroll | IServerError | IResponse | any> => {
		try {
			const response: AxiosResponse<IPayroll> = await http.post<IPayroll>(
				`/v1/employee-payroll-adjustments/replacing-entry/`,
				requestPayload.payrollData,
			);

			if (response.status === 201) {
				return response;
			} else if (response.status === 400) {
				return response.data;
			} else if (response.status === 401) {
				// window.location.href = '/logout';
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				requestPayload.navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else if (axiosError && axiosError.status === 422) {
				return {
					status: false,
					message: `Errors : \n${format422Errors(axiosError?.response?.data)}`,
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},
	directDeposit: async (
		requestPayload: any,
	): Promise<IPayroll | IServerError | IResponse | any> => {
		try {
			const response: AxiosResponse<IPayroll> = await http.post<IPayroll>(
				`/v1/direct-deposit/?client_id=${requestPayload.payrollData.clientId}&pay_period_frequency_id=${requestPayload.payrollData.payPeriodFrequencyId}&pay_period_start_date=${requestPayload.payrollData.payPeriodStarDate}&pay_period_end_date=${requestPayload.payrollData.payPeriodEndDate}`,
				// requestPayload.data
			);

			if (response.status === 201) {
				return response;
			} else if (response.status === 400) {
				return response.data;
			} else if (response.status === 401) {
				// window.location.href = '/logout';
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				requestPayload.navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else if (axiosError && axiosError.status === 422) {
				return {
					status: false,
					message: `Errors : \n${format422Errors(axiosError?.response?.data)}`,
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},
	cancelProcess: async (
		requestPayload: any,
	): Promise<IPayroll | IServerError | IResponse | any> => {
		try {
			const response: AxiosResponse<IPayroll> = await http.put<IPayroll>(
				`/v1/transaction-log/${requestPayload.payrollData.clientId}/undo-processes/?invoice_id=${requestPayload.payrollData.invoiceNo}&pay_period_end_date=${requestPayload.payrollData.payPeriodEndDate}&payroll_schedule_id=${requestPayload.payrollData.payPeriodFrequencyId}`,
			);

			if (response.status === 200) {
				return response;
			} else if (response.status === 400) {
				return response.data;
			} else if (response.status === 401) {
				// window.location.href = '/logout';
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				requestPayload.navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else if (axiosError && axiosError.status === 422) {
				return {
					status: false,
					message: `Errors : \n${format422Errors(axiosError?.response?.data)}`,
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},
	insertEmployeePayrollData: async (
		requestPayload: any,
	): Promise<IPayroll | IServerError | IResponse | any> => {
		try {
			const response: AxiosResponse<IPayroll> = await http.post<IPayroll>(
				"/v1/employee-payroll-data/inserting-data/",
				requestPayload.data,
			);

			if (response.status === 201) {
				return response;
			} else if (response.status === 400) {
				return response.data;
			} else if (response.status === 401) {
				// window.location.href = '/logout';
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				requestPayload.navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else if (axiosError && axiosError.status === 422) {
				return {
					status: false,
					message: `Errors : \n${format422Errors(axiosError?.response?.data)}`,
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},
	insertEmployeePayrollAdjustmentData: async (
		requestPayload: any,
	): Promise<IPayroll | IServerError | IResponse | any> => {
		try {
			const response: AxiosResponse<IPayroll> = await http.post<IPayroll>(
				"/v1/employee-payroll-data/inserting-data/",
				requestPayload.data,
			);

			if (response.status === 201) {
				return response;
			} else if (response.status === 400) {
				return response.data;
			} else if (response.status === 401) {
				// window.location.href = '/logout';
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				requestPayload.navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else if (axiosError && axiosError.status === 422) {
				return {
					status: false,
					message: `Errors : \n${format422Errors(axiosError?.response?.data)}`,
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},
	delEmployeePayrollData: async (
		delEmployeePayrollDataPayload: any,
	): Promise<string | IServerError | IResponse | any> => {
		try {
			const response: AxiosResponse<IPayroll> = await http.put<IPayroll>(
				"/v1/employee-payroll-data/",
				delEmployeePayrollDataPayload.data,
			);

			if (response.status === 200) {
				return "Record has been deleted successfully.";
			} else if (response.status === 400) {
				return response.data;
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				delEmployeePayrollDataPayload.navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},
	delEmployeePayrollAdjustmentData: async (
		delEmployeePayrollDataPayload: any,
	): Promise<string | IServerError | IResponse | any> => {
		try {
			const response: AxiosResponse<IPayroll> = await http.put<IPayroll>(
				"/v1/employee-payroll-adjustments/remove-data/",
				delEmployeePayrollDataPayload.data,
			);

			if (response.status === 201) {
				return "Record has been deleted successfully.";
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				delEmployeePayrollDataPayload.navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},

	editingCalculatdePayroll: async ({
		clientId,
		data,
		navigateToLogout,
	}: {
		clientId: string;
		data: any;
		navigateToLogout: (path: any) => void;
	}): Promise<IPayroll | IServerError | IResponse | any> => {
		try {
			const response: AxiosResponse<IPayroll> = await http.put<IPayroll>(
				`/v1/employee-payroll-data/${clientId}/edit/`,
				data,
			);
			if (response.status === 200) {
				return response;
			} else if (response.status === 400) {
				return response.data;
			} else if (response.status === 401) {
				// window.location.href = '/logout';
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else if (axiosError && axiosError.status === 422) {
				return {
					status: false,
					message: `Errors : \n${format422Errors(axiosError?.response?.data)}`,
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},
	editingCalculatdePayrollAdjustment: async ({
		clientId,
		data,
		navigateToLogout,
	}: {
		clientId: string;
		data: any;
		navigateToLogout: (path: any) => void;
	}): Promise<IPayroll | IServerError | IResponse | any> => {
		try {
			const response: AxiosResponse<IPayroll> = await http.put<IPayroll>(
				`/v1/employee-payroll-adjustments/${clientId}/edit/`,
				data,
			);
			if (response.status === 200) {
				return response;
			} else if (response.status === 400) {
				return response.data;
			} else if (response.status === 401) {
				// window.location.href = '/logout';
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else if (axiosError && axiosError.status === 422) {
				return {
					status: false,
					message: `Errors : \n${format422Errors(axiosError?.response?.data)}`,
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},
	savingCalculatdePayroll: async ({
		clientId,
		data,
		navigateToLogout,
	}: {
		clientId: string;
		data: any;
		navigateToLogout: (path: any) => void;
	}): Promise<IPayroll | IServerError | IResponse | any> => {
		try {
			const response: AxiosResponse<IPayroll> = await http.put<IPayroll>(
				`/v1/employee-payroll-data/save/${clientId}/`,
				data,
			);

			if (response.status === 200) {
				return response;
			} else if (response.status === 400) {
				return response.data;
			} else if (response.status === 401) {
				// window.location.href = '/logout';
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else if (axiosError && axiosError.status === 422) {
				return {
					status: false,
					message: `Errors : \n${format422Errors(axiosError?.response?.data)}`,
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},
	overwriteCalculatdePayroll: async ({
		clientId,
		data,
		navigateToLogout,
	}: {
		clientId: string;
		data: any;
		navigateToLogout: (path: any) => void;
	}): Promise<IPayroll | IServerError | IResponse | any> => {
		try {
			const response: AxiosResponse<IPayroll> = await http.put<IPayroll>(
				`/v1/employee-payroll-data/${clientId}/`,
				data,
			);

			if (response.status === 200) {
				return response;
			} else if (response.status === 400) {
				return response.data;
			} else if (response.status === 401) {
				// window.location.href = '/logout';
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else if (axiosError && axiosError.status === 422) {
				return {
					status: false,
					message: `Errors : \n${format422Errors(axiosError?.response?.data)}`,
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},
	overwriteCalculatdePayrollAdjustment: async ({
		clientId,
		data,
		navigateToLogout,
	}: {
		clientId: string;
		data: any;
		navigateToLogout: (path: any) => void;
	}): Promise<IPayroll | IServerError | IResponse | any> => {
		try {
			const response: AxiosResponse<IPayroll> = await http.put<IPayroll>(
				`/v1/employee-payroll-adjustments/${clientId}/overwrite/adjusted`,
				data,
			);

			if (response.status === 200) {
				return response;
			} else if (response.status === 400) {
				return response.data;
			} else if (response.status === 401) {
				// window.location.href = '/logout';
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else if (axiosError && axiosError.status === 422) {
				return {
					status: false,
					message: `Errors : \n${format422Errors(axiosError?.response?.data)}`,
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},
	getPayrollPeriodsDDL: async (
		clientId: string,
		payPeriodId: string | null,
		taxYear: number,
	): Promise<any | IServerError | IResponse | null | any> => {
		if (payPeriodId) {
			try {
				const response: AxiosResponse<any> = await http.get<any>(
					`/v1/payroll-schedule/ddl/for-payrol/?client_id=${clientId}&pay_period=${payPeriodId}&tax_year=${taxYear}`,
				);

				if (response.status === 200) {
					return response.data;
				} else if (response.status === 404) {
					return [];
				} else if (response.status === 500) {
					return {
						status: false,
						message: "Something went wrong.",
						error: true,
					};
				}

				return {
					status: false,
					message: "Something went wrong please try again later.",
				};
			} catch (error) {
				const axiosError = error as AxiosError;
				console.error("An error occurred:", axiosError);
				const errorMessage =
					axiosError.response && typeof axiosError.response.data === "string"
						? axiosError.response.data
						: "Unknown error";
				if (axiosError && axiosError.status === 404) {
					return [];
				} else {
					return {
						status: false,
						message: errorMessage,
					};
				}
			}
		}
		return null;
	},
	getActiveEmployeesByPeriodsDDL: async (
		clientId: string,
		payPeriodId: string | null,
		payPeriodEndDate: string | null,
	): Promise<any | IServerError | IResponse | null | any> => {
		if (payPeriodId && payPeriodEndDate) {
			try {
				const response: AxiosResponse<any> = await http.get<any>(
					`/v1/time-sheet/timesheet/${clientId}/?payroll_shedule_id=${payPeriodId}&pay_period_end_date=${payPeriodEndDate}`,
				);

				if (response.status === 200) {
					return response.data;
				} else if (response.status === 404) {
					return [];
				} else if (response.status === 500) {
					return {
						status: false,
						message: "Something went wrong.",
						error: true,
					};
				}

				return {
					status: false,
					message: "Something went wrong please try again later.",
				};
			} catch (error) {
				const axiosError = error as AxiosError;
				console.error("An error occurred:", axiosError);
				const errorMessage =
					axiosError.response && typeof axiosError.response.data === "string"
						? axiosError.response.data
						: "Unknown error";
				if (axiosError && axiosError.status === 404) {
					return [];
				} else {
					return {
						status: false,
						message: errorMessage,
					};
				}
			}
		}
		return null;
	},
	getVocationalEarningsList: async (
		clientId: string,
	): Promise<any | IServerError | IResponse | null | any> => {
		// let fixed = {
		//   vocationableEarnings: {
		//     "682b1d646e7ce7f627faa331": [
		//       "regularGross",
		//       "regularHours",
		//       "vacationPay",
		//       "commission",
		//       "ot1Dot5Hours",
		//       "ot2Dot0Hours",
		//       "grossIncome",
		//     ],
		//     "69425242f639c2c0be9b2aa4": [
		//       "regularHours",
		//       "ot1Dot5Hours",
		//       "ot2Dot0Hours",
		//       "grossIncome",
		//     ],
		//   },
		//   edr: ["earning"],
		// };
		// return new Promise((resolve) => setTimeout(() => resolve(fixed), 1000));

		try {
			const response: AxiosResponse<any> = await http.get<any>(
				`/v1/payroll-vocational-earning/get/vocational-list/?client_id=${clientId}`,
			);

			if (response.status === 200) {
				return response.data;
			} else if (response.status === 404) {
				return [];
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 404) {
				return [];
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},
	createPayrollFrequency: async (
		clientId: string,
		remittanceFrequencyId: string | undefined,
		managedBy: number,
		taxYear: number,
		navigateToLogout: (path: string) => void,
	): Promise<IPayroll | IServerError | IResponse | any> => {
		try {
			const response: AxiosResponse<IPayroll> = await http.post<IPayroll>(
				`/v1/payroll/?client_id=${clientId}&remittance_frequency_id=${remittanceFrequencyId}&tax_year=${taxYear}&managed_by=${managedBy}`,
			);

			if (response.status === 200) {
				return response;
			} else if (response.status === 400) {
				return response.data;
			} else if (response.status === 401) {
				// window.location.href = '/logout';
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else if (axiosError && axiosError.status === 422) {
				return {
					status: false,
					message: `Errors : \n${format422Errors(axiosError?.response?.data)}`,
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},

	/////////////////////////////////////////// Stub Printing Payroll /////////////////////////////////////////////

	createStubPayrollPdfPrint: async (
		requestPayload: any,
	): Promise<IServerError | IResponse | any> => {
		// const requestData = {
		//   employee_id :employeeId,
		//   client_id:clientId,
		// };
		const url = `/v1/payroll-stub-printing/?client_id=${requestPayload.clientId}`;
		const response: any = await http.post(url, requestPayload.empIds, {
			responseType: "arraybuffer",
		});
		if (response.status === 201) {
			return response.data;
		} else if (response.status === 400) {
			const text = new TextDecoder().decode(response.data);
			const responseObject = JSON.parse(text);
			let response400 = {
				...response,
				data: responseObject,
			};
			return response400;
		} else if (response.status === 500) {
			return {
				status: false,
				message: "Something went wrong.",
				error: true,
			};
		}
		// }
		return {
			status: false,
			message: "Something went wrong please try again later.",
		};
	},

	createPayrollAdjustmentAddEmployeePanel: async (
		// clientId:string,
		requestPayload: any,
		// taxYear:number,
	): Promise<any | IServerError | IResponse> => {
		let response: AxiosResponse<any>;
		response = await http.put<any>(
			`/v1/open-balance-assign-employee/assign-unassign?association_flag=${requestPayload.flag}`, // open balance api
			{ items: requestPayload.items },
			// `/v1/statutory-holiday-employee-eligibility/${requestPayload.employeeId}/?association_flag=${requestPayload.flag}` // statutory api
			// `/v1/open-balance-assign-employee/?client_id=${clientId}&employee_id=${request.employeeId}&tax_year=${taxYear}&association_flag=${requestPayload.flag}`
		);

		if (response.status === 201 || response.status === 200) {
			return response.data;
		} else if (response.status === 200) {
			let responseWithFlag = {
				client: response.data,
				status: requestPayload.flag,
			};
			return responseWithFlag;
			// return response.data;
		} else if (response.status === 400) {
			return {
				status: false,
				message: "400 Bad Request.",
				error: true,
			};
		} else if (response.status === 500) {
			return {
				status: false,
				message: "Something went wrong.",
				error: true,
			};
		}

		return {
			status: false,
			message: "Something went wrong please try again later.",
		};
	},

	getPayrollAdjustmentAddEmployeePanel: async (
		clientId: string,
		taxYear: number,
		selectedPayPeriodId: string | undefined | null,
		payPeriodEndDate: string | undefined | null,
	): Promise<
		IPayrollYearToDateAddEmployeePanel | IServerError | IResponse | null
	> => {
		if (!selectedPayPeriodId || !payPeriodEndDate) return null;
		const response: AxiosResponse<IPayrollYearToDateAddEmployeePanel> =
			await http.get<IPayrollYearToDateAddEmployeePanel>(
				`/v1/employee-payroll-adjustments/${clientId}/?payroll_shedule_id=${selectedPayPeriodId}&pay_period_end_date=${payPeriodEndDate}`,
			);
		if (response.status === 200) {
			return response.data;
		} else if (response.status === 500) {
			return {
				status: false,
				message: "Something went wrong.",
				error: true,
			};
		}

		return {
			status: false,
			message: "Something went wrong please try again later.",
		};
	},
	assignEmployees: async (
		requestPayload: any,
	): Promise<IServerError | IResponse | any> => {
		const response: AxiosResponse<any> = await http.post<any>(
			`/v1/employee-payroll-adjustments/`,
			requestPayload,
		);

		if (response.status === 201) {
			return response;
		} else if (response.status === 400) {
			return response;
		} else if (response.status === 500) {
			return {
				status: false,
				message: "Something went wrong.",
				error: true,
			};
		}

		return {
			status: false,
			message: "Something went wrong please try again later.",
		};
	},
	unAssignEmployees: async (
		requestPayload: any,
	): Promise<IServerError | IResponse | any> => {
		const response: AxiosResponse<any> = await http.put<any>(
			`/v1/employee-payroll-adjustments/remove-data/`,
			requestPayload,
		);

		if (response.status === 201) {
			return response;
		} else if (response.status === 400) {
			return response;
		} else if (response.status === 500) {
			return {
				status: false,
				message: "Something went wrong.",
				error: true,
			};
		}

		return {
			status: false,
			message: "Something went wrong please try again later.",
		};
	},
	getTD1FieldsDDL: async (
		employeeId: string,
		provinceId: string,
		defaultDate: string,
	): Promise<any | IServerError | IResponse | null> => {
		if (employeeId) {
			const response: AxiosResponse<IDropDownListResponse[]> = await http.get<
				IDropDownListResponse[]
			>(
				`/v1/employee-td1-form/ddl/for-adjustments/?employee_id=${employeeId}&province_id=${provinceId}&default_date=${defaultDate}`,
			);

			if (response.status === 200) {
				return response.data;
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} else {
			return null;
		}
	},
	getEngineFieldsDDL: async (
		taxYear: number,
		provinceId: string,
		defaultDate: string,
	): Promise<any | IServerError | IResponse | null> => {
		if (taxYear) {
			const response: AxiosResponse<IDropDownListResponse[]> = await http.get<
				IDropDownListResponse[]
			>(
				`/v1/global-variable/global-variable-ddl/for-adjustments/?tax_year=${taxYear}&province=${provinceId}&default_date=${defaultDate}`,
			);

			if (response.status === 200) {
				return response.data;
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} else {
			return null;
		}
	},
	getPayrollAdjustmentSettingEmployeeFields: async (
		clientId: string,
		employeeId: string | null,
		payPeriodEndDate: string | null,
		payPeriodFrequencyId: string | null,
	): Promise<
		IPayrollYearToDateAddEmployeePanel | IServerError | IResponse | null
	> => {
		if (!employeeId) return null;
		const response: AxiosResponse<IPayrollYearToDateAddEmployeePanel> =
			await http.get<IPayrollYearToDateAddEmployeePanel>(
				`/v1/employee-payroll-adjustments/${clientId}/get/engine/details/?employee_id=${employeeId}&pay_period_end_date=${payPeriodEndDate}&payroll_shedule_id=${payPeriodFrequencyId}`,
			);
		if (response.status === 200) {
			return response.data;
		} else if (response.status === 500) {
			return {
				status: false,
				message: "Something went wrong.",
				error: true,
			};
		}

		return {
			status: false,
			message: "Something went wrong please try again later.",
		};
	},
	submitPayrollAdjustmentFieldsData: async (
		requestPayload: any,
	): Promise<IPayroll | IServerError | IResponse | any> => {
		try {
			const response: AxiosResponse<IPayroll> = await http.put<IPayroll>(
				`/v1/employee-payroll-adjustments/${requestPayload.clientId}/updating/engine/details/`,
				requestPayload,
			);

			if (response.status === 200) {
				return response;
			} else if (response.status === 400) {
				return response.data;
			} else if (response.status === 401) {
				// window.location.href = '/logout';
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 422) {
				return {
					status: false,
					message: `Errors : \n${format422Errors(axiosError?.response?.data)}`,
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},
	getPayrollTimeSheet: async (
		clientId: string,
		payPeriodFrequencyId: string | null,
		payPeriodStarDate: string | null,
		payPeriodEndDate: string | null,
		selectedEmployeeId: string | null,
		workFormat: number,
		inputHours: number,
		navigateToLogout: (path: string) => void,
	): Promise<
		IPayrollListPayload | IServerError | IResponse | IPayrollResponse[] | null
	> => {
		if (payPeriodFrequencyId && payPeriodStarDate && payPeriodEndDate) {
			try {
				const response: AxiosResponse<IPayrollListPayload> =
					await http.get<IPayrollListPayload>(
						"/v1/time-sheet/?client_id=" +
							clientId +
							"&employee_id=" +
							selectedEmployeeId +
							"&pay_period_start_date=" +
							payPeriodStarDate +
							"&pay_period_end_date=" +
							payPeriodEndDate +
							"&work_format=" +
							workFormat +
							"&input_hours=" +
							inputHours +
							"&payroll_shedule_id=" +
							payPeriodFrequencyId,
					);
				if (response.status === 200) {
					return response.data;
				} else if (response.status === 201) {
					return response.data;
				} else if (response.status === 400) {
					return {
						status: false,
						message: "Bad Request.",
						error: true,
					};
				} else if (response.status === 500) {
					return {
						status: false,
						message: "Something went wrong.",
						error: true,
					};
				}
				return {
					status: false,
					message: "Something went wrong please try again later.",
				};
			} catch (error) {
				const axiosError = error as AxiosError;
				console.error("An error occurred:", axiosError);
				const errorMessage =
					axiosError.response && typeof axiosError.response.data === "string"
						? axiosError.response.data
						: "Unknown error";
				if (axiosError && axiosError.status === 401) {
					navigateToLogout("/logout");
					return {
						status: false,
						message: "UnAuthrized",
					};
				} else {
					return {
						status: false,
						message: errorMessage,
					};
				}
			}
		}

		return null;

		// if (workFormat === 100) {
		//   const fixedResponse: any = {
		//     page: null,
		//     size: null,
		//     total: null,
		//     items: [
		//       {
		//         description: "123",
		//         project1: "simplepay",
		//         project1Values: [
		//           { label: "SimplePay", value: "simplepay" },
		//           { label: "Taxslips", value: "taxslips" },
		//         ],
		//         location: "",
		//         days: {
		//           "2026-01-01": {
		//             hours: null,
		//           },
		//           "2026-01-02": {
		//             hours: null,
		//           },
		//           "2026-01-03": {
		//             hours: null,
		//           },
		//           "2026-01-04": {
		//             hours: null,
		//           },
		//           "2026-01-05": {
		//             hours: null,
		//           },
		//           "2026-01-06": {
		//             hours: null,
		//           },
		//           "2026-01-07": {
		//             hours: null,
		//           },
		//           "2026-01-08": {
		//             hours: null,
		//           },
		//           "2026-01-09": {
		//             hours: null,
		//           },
		//           "2026-01-10": {
		//             hours: null,
		//           },
		//           "2026-01-11": {
		//             hours: null,
		//           },
		//           "2026-01-12": {
		//             hours: null,
		//           },
		//           "2026-01-13": {
		//             hours: null,
		//           },
		//           "2026-01-14": {
		//             hours: null,
		//           },
		//           "2026-01-15": {
		//             hours: null,
		//           },
		//         },
		//       },
		//       {
		//         description: null,
		//         days: {
		//           "2026-01-01": {
		//             hours: null,
		//           },
		//           "2026-01-02": {
		//             hours: null,
		//           },
		//           "2026-01-03": {
		//             hours: null,
		//           },
		//           "2026-01-04": {
		//             hours: null,
		//           },
		//           "2026-01-05": {
		//             hours: null,
		//           },
		//           "2026-01-06": {
		//             hours: null,
		//           },
		//           "2026-01-07": {
		//             hours: null,
		//           },
		//           "2026-01-08": {
		//             hours: null,
		//           },
		//           "2026-01-09": {
		//             hours: null,
		//           },
		//           "2026-01-10": {
		//             hours: null,
		//           },
		//           "2026-01-11": {
		//             hours: null,
		//           },
		//           "2026-01-12": {
		//             hours: null,
		//           },
		//           "2026-01-13": {
		//             hours: null,
		//           },
		//           "2026-01-14": {
		//             hours: null,
		//           },
		//           "2026-01-15": {
		//             hours: null,
		//           },
		//         },
		//       },
		//       {
		//         description: null,
		//         days: {
		//           "2026-01-01": {
		//             hours: null,
		//           },
		//           "2026-01-02": {
		//             hours: null,
		//           },
		//           "2026-01-03": {
		//             hours: null,
		//           },
		//           "2026-01-04": {
		//             hours: null,
		//           },
		//           "2026-01-05": {
		//             hours: null,
		//           },
		//           "2026-01-06": {
		//             hours: null,
		//           },
		//           "2026-01-07": {
		//             hours: null,
		//           },
		//           "2026-01-08": {
		//             hours: null,
		//           },
		//           "2026-01-09": {
		//             hours: null,
		//           },
		//           "2026-01-10": {
		//             hours: null,
		//           },
		//           "2026-01-11": {
		//             hours: null,
		//           },
		//           "2026-01-12": {
		//             hours: null,
		//           },
		//           "2026-01-13": {
		//             hours: null,
		//           },
		//           "2026-01-14": {
		//             hours: null,
		//           },
		//           "2026-01-15": {
		//             hours: null,
		//           },
		//         },
		//       },
		//       {
		//         description: null,
		//         days: {
		//           "2026-01-01": {
		//             hours: null,
		//           },
		//           "2026-01-02": {
		//             hours: null,
		//           },
		//           "2026-01-03": {
		//             hours: null,
		//           },
		//           "2026-01-04": {
		//             hours: null,
		//           },
		//           "2026-01-05": {
		//             hours: null,
		//           },
		//           "2026-01-06": {
		//             hours: null,
		//           },
		//           "2026-01-07": {
		//             hours: null,
		//           },
		//           "2026-01-08": {
		//             hours: null,
		//           },
		//           "2026-01-09": {
		//             hours: null,
		//           },
		//           "2026-01-10": {
		//             hours: null,
		//           },
		//           "2026-01-11": {
		//             hours: null,
		//           },
		//           "2026-01-12": {
		//             hours: null,
		//           },
		//           "2026-01-13": {
		//             hours: null,
		//           },
		//           "2026-01-14": {
		//             hours: null,
		//           },
		//           "2026-01-15": {
		//             hours: null,
		//           },
		//         },
		//       },
		//       {
		//         description: null,
		//         days: {
		//           "2026-01-01": {
		//             hours: null,
		//           },
		//           "2026-01-02": {
		//             hours: null,
		//           },
		//           "2026-01-03": {
		//             hours: null,
		//           },
		//           "2026-01-04": {
		//             hours: null,
		//           },
		//           "2026-01-05": {
		//             hours: null,
		//           },
		//           "2026-01-06": {
		//             hours: null,
		//           },
		//           "2026-01-07": {
		//             hours: null,
		//           },
		//           "2026-01-08": {
		//             hours: null,
		//           },
		//           "2026-01-09": {
		//             hours: null,
		//           },
		//           "2026-01-10": {
		//             hours: null,
		//           },
		//           "2026-01-11": {
		//             hours: null,
		//           },
		//           "2026-01-12": {
		//             hours: null,
		//           },
		//           "2026-01-13": {
		//             hours: null,
		//           },
		//           "2026-01-14": {
		//             hours: null,
		//           },
		//           "2026-01-15": {
		//             hours: null,
		//           },
		//         },
		//       },
		//     ],
		//     keyField: null,
		//     headerColumns: [
		//       {
		//         field: "project1",
		//         headerName: "Project 1",
		//         description: null,
		//         flex: 1,
		//         hide: false,
		//         hideable: false,
		//         sortable: true,
		//         sortingOrder: "asc",
		//         resizable: false,
		//         type: "dropdown",
		//         align: "left",
		//         headerAlign: "left",
		//         hideSortIcons: false,
		//         disableColumnMenu: true,
		//         disableReorder: true,
		//         disableExport: true,
		//         maskable: false,
		//         isFixed: true,
		//         isEditable: true,
		//         sequence: 1,
		//         frozenColumn: false,
		//         footer: null,
		//         minWidth: null,
		//         maxWidth: null,
		//         fieldName: null,
		//         edr: "edr",
		//       },
		//       {
		//         field: "location",
		//         headerName: "Location",
		//         description: null,
		//         flex: 1,
		//         hide: false,
		//         hideable: false,
		//         sortable: true,
		//         sortingOrder: "asc",
		//         resizable: false,
		//         type: "text",
		//         align: "left",
		//         headerAlign: "left",
		//         hideSortIcons: false,
		//         disableColumnMenu: true,
		//         disableReorder: true,
		//         disableExport: true,
		//         maskable: false,
		//         isFixed: true,
		//         isEditable: true,
		//         sequence: 2,
		//         frozenColumn: false,
		//         footer: null,
		//         minWidth: null,
		//         maxWidth: null,
		//         fieldName: null,
		//         edr: "edr",
		//       },
		//       {
		//         field: "description",
		//         headerName: "Description",
		//         description: null,
		//         flex: 1,
		//         hide: false,
		//         hideable: false,
		//         sortable: true,
		//         sortingOrder: "asc",
		//         resizable: false,
		//         type: "text",
		//         align: "left",
		//         headerAlign: "left",
		//         hideSortIcons: false,
		//         disableColumnMenu: true,
		//         disableReorder: true,
		//         disableExport: true,
		//         maskable: false,
		//         isFixed: true,
		//         isEditable: true,
		//         sequence: 4,
		//         frozenColumn: false,
		//         footer: null,
		//         minWidth: null,
		//         maxWidth: null,
		//         fieldName: null,
		//         edr: "edr",
		//       },
		//       {
		//         field: "days.2026-01-01.hours",
		//         headerName: "Thu 1",
		//         description: "2026-01-01",
		//         flex: 1,
		//         hide: false,
		//         hideable: false,
		//         sortable: true,
		//         sortingOrder: "asc",
		//         resizable: false,
		//         type: "number",
		//         align: "left",
		//         headerAlign: "center",
		//         hideSortIcons: false,
		//         disableColumnMenu: true,
		//         disableReorder: true,
		//         disableExport: true,
		//         maskable: false,
		//         isFixed: true,
		//         isEditable: true,
		//         sequence: 5,
		//         frozenColumn: false,
		//         footer: null,
		//         minWidth: null,
		//         maxWidth: null,
		//         fieldName: null,
		//         edr: "edr",

		//         weekendColumn: null,
		//       },
		//       {
		//         field: "2026-01-02",
		//         headerName: "Fri 2",
		//         description: "2026-01-02",
		//         flex: 1,
		//         hide: false,
		//         hideable: false,
		//         sortable: true,
		//         sortingOrder: "asc",
		//         resizable: false,
		//         type: "number",
		//         align: "left",
		//         headerAlign: "center",
		//         hideSortIcons: false,
		//         disableColumnMenu: true,
		//         disableReorder: true,
		//         disableExport: true,
		//         maskable: false,
		//         isFixed: true,
		//         isEditable: true,
		//         sequence: 6,
		//         frozenColumn: false,
		//         footer: null,
		//         minWidth: null,
		//         maxWidth: null,
		//         fieldName: null,
		//         edr: "edr",

		//         weekendColumn: null,
		//       },
		//       {
		//         field: "2026-01-03",
		//         headerName: "Sat 3",
		//         description: "2026-01-03",
		//         flex: 1,
		//         hide: false,
		//         hideable: false,
		//         sortable: true,
		//         sortingOrder: "asc",
		//         resizable: false,
		//         type: "number",
		//         align: "left",
		//         headerAlign: "center",
		//         hideSortIcons: false,
		//         disableColumnMenu: true,
		//         disableReorder: true,
		//         disableExport: true,
		//         maskable: false,
		//         isFixed: true,
		//         isEditable: true,
		//         sequence: 7,
		//         frozenColumn: false,
		//         footer: null,
		//         minWidth: null,
		//         maxWidth: null,
		//         fieldName: null,
		//         edr: "edr",

		//         weekendColumn: true,
		//       },
		//       {
		//         field: "2026-01-04",
		//         headerName: "Sun 4",
		//         description: "2026-01-04",
		//         flex: 1,
		//         hide: false,
		//         hideable: false,
		//         sortable: true,
		//         sortingOrder: "asc",
		//         resizable: false,
		//         type: "number",
		//         align: "left",
		//         headerAlign: "center",
		//         hideSortIcons: false,
		//         disableColumnMenu: true,
		//         disableReorder: true,
		//         disableExport: true,
		//         maskable: false,
		//         isFixed: true,
		//         isEditable: true,
		//         sequence: 8,
		//         frozenColumn: false,
		//         footer: null,
		//         minWidth: null,
		//         maxWidth: null,
		//         fieldName: null,
		//         edr: "edr",

		//         weekendColumn: true,
		//       },
		//       {
		//         field: "2026-01-05",
		//         headerName: "Mon 5",
		//         description: "2026-01-05",
		//         flex: 1,
		//         hide: false,
		//         hideable: false,
		//         sortable: true,
		//         sortingOrder: "asc",
		//         resizable: false,
		//         type: "number",
		//         align: "left",
		//         headerAlign: "center",
		//         hideSortIcons: false,
		//         disableColumnMenu: true,
		//         disableReorder: true,
		//         disableExport: true,
		//         maskable: false,
		//         isFixed: true,
		//         isEditable: true,
		//         sequence: 9,
		//         frozenColumn: false,
		//         footer: null,
		//         minWidth: null,
		//         maxWidth: null,
		//         fieldName: null,
		//         edr: "edr",

		//         weekendColumn: null,
		//       },
		//       {
		//         field: "2026-01-06",
		//         headerName: "Tue 6",
		//         description: "2026-01-06",
		//         flex: 1,
		//         hide: false,
		//         hideable: false,
		//         sortable: true,
		//         sortingOrder: "asc",
		//         resizable: false,
		//         type: "number",
		//         align: "left",
		//         headerAlign: "center",
		//         hideSortIcons: false,
		//         disableColumnMenu: true,
		//         disableReorder: true,
		//         disableExport: true,
		//         maskable: false,
		//         isFixed: true,
		//         isEditable: true,
		//         sequence: 10,
		//         frozenColumn: false,
		//         footer: null,
		//         minWidth: null,
		//         maxWidth: null,
		//         fieldName: null,
		//         edr: "edr",

		//         weekendColumn: null,
		//       },
		//       {
		//         field: "2026-01-07",
		//         headerName: "Wed 7",
		//         description: "2026-01-07",
		//         flex: 1,
		//         hide: false,
		//         hideable: false,
		//         sortable: true,
		//         sortingOrder: "asc",
		//         resizable: false,
		//         type: "number",
		//         align: "left",
		//         headerAlign: "center",
		//         hideSortIcons: false,
		//         disableColumnMenu: true,
		//         disableReorder: true,
		//         disableExport: true,
		//         maskable: false,
		//         isFixed: true,
		//         isEditable: true,
		//         sequence: 11,
		//         frozenColumn: false,
		//         footer: null,
		//         minWidth: null,
		//         maxWidth: null,
		//         fieldName: null,
		//         edr: "edr",

		//         weekendColumn: null,
		//       },
		//       {
		//         field: "2026-01-08",
		//         headerName: "Thu 8",
		//         description: "2026-01-08",
		//         flex: 1,
		//         hide: false,
		//         hideable: false,
		//         sortable: true,
		//         sortingOrder: "asc",
		//         resizable: false,
		//         type: "number",
		//         align: "left",
		//         headerAlign: "center",
		//         hideSortIcons: false,
		//         disableColumnMenu: true,
		//         disableReorder: true,
		//         disableExport: true,
		//         maskable: false,
		//         isFixed: true,
		//         isEditable: true,
		//         sequence: 12,
		//         frozenColumn: false,
		//         footer: null,
		//         minWidth: null,
		//         maxWidth: null,
		//         fieldName: null,
		//         edr: "edr",

		//         weekendColumn: null,
		//       },
		//       {
		//         field: "2026-01-09",
		//         headerName: "Fri 9",
		//         description: "2026-01-09",
		//         flex: 1,
		//         hide: false,
		//         hideable: false,
		//         sortable: true,
		//         sortingOrder: "asc",
		//         resizable: false,
		//         type: "number",
		//         align: "left",
		//         headerAlign: "center",
		//         hideSortIcons: false,
		//         disableColumnMenu: true,
		//         disableReorder: true,
		//         disableExport: true,
		//         maskable: false,
		//         isFixed: true,
		//         isEditable: true,
		//         sequence: 13,
		//         frozenColumn: false,
		//         footer: null,
		//         minWidth: null,
		//         maxWidth: null,
		//         fieldName: null,
		//         edr: "edr",

		//         weekendColumn: null,
		//       },
		//       {
		//         field: "2026-01-10",
		//         headerName: "Sat 10",
		//         description: "2026-01-10",
		//         flex: 1,
		//         hide: false,
		//         hideable: false,
		//         sortable: true,
		//         sortingOrder: "asc",
		//         resizable: false,
		//         type: "number",
		//         align: "left",
		//         headerAlign: "center",
		//         hideSortIcons: false,
		//         disableColumnMenu: true,
		//         disableReorder: true,
		//         disableExport: true,
		//         maskable: false,
		//         isFixed: true,
		//         isEditable: true,
		//         sequence: 14,
		//         frozenColumn: false,
		//         footer: null,
		//         minWidth: null,
		//         maxWidth: null,
		//         fieldName: null,
		//         edr: "edr",

		//         weekendColumn: true,
		//       },
		//       {
		//         field: "2026-01-11",
		//         headerName: "Sun 11",
		//         description: "2026-01-11",
		//         flex: 1,
		//         hide: false,
		//         hideable: false,
		//         sortable: true,
		//         sortingOrder: "asc",
		//         resizable: false,
		//         type: "number",
		//         align: "left",
		//         headerAlign: "center",
		//         hideSortIcons: false,
		//         disableColumnMenu: true,
		//         disableReorder: true,
		//         disableExport: true,
		//         maskable: false,
		//         isFixed: true,
		//         isEditable: true,
		//         sequence: 15,
		//         frozenColumn: false,
		//         footer: null,
		//         minWidth: null,
		//         maxWidth: null,
		//         fieldName: null,
		//         edr: "edr",

		//         weekendColumn: true,
		//       },
		//       {
		//         field: "2026-01-12",
		//         headerName: "Mon 12",
		//         description: "2026-01-12",
		//         flex: 1,
		//         hide: false,
		//         hideable: false,
		//         sortable: true,
		//         sortingOrder: "asc",
		//         resizable: false,
		//         type: "number",
		//         align: "left",
		//         headerAlign: "center",
		//         hideSortIcons: false,
		//         disableColumnMenu: true,
		//         disableReorder: true,
		//         disableExport: true,
		//         maskable: false,
		//         isFixed: true,
		//         isEditable: true,
		//         sequence: 16,
		//         frozenColumn: false,
		//         footer: null,
		//         minWidth: null,
		//         maxWidth: null,
		//         fieldName: null,
		//         edr: "edr",

		//         weekendColumn: null,
		//       },
		//       {
		//         field: "2026-01-13",
		//         headerName: "Tue 13",
		//         description: "2026-01-13",
		//         flex: 1,
		//         hide: false,
		//         hideable: false,
		//         sortable: true,
		//         sortingOrder: "asc",
		//         resizable: false,
		//         type: "number",
		//         align: "left",
		//         headerAlign: "center",
		//         hideSortIcons: false,
		//         disableColumnMenu: true,
		//         disableReorder: true,
		//         disableExport: true,
		//         maskable: false,
		//         isFixed: true,
		//         isEditable: true,
		//         sequence: 17,
		//         frozenColumn: false,
		//         footer: null,
		//         minWidth: null,
		//         maxWidth: null,
		//         fieldName: null,
		//         edr: "edr",

		//         weekendColumn: null,
		//       },
		//       {
		//         field: "2026-01-14",
		//         headerName: "Wed 14",
		//         description: "2026-01-14",
		//         flex: 1,
		//         hide: false,
		//         hideable: false,
		//         sortable: true,
		//         sortingOrder: "asc",
		//         resizable: false,
		//         type: "number",
		//         align: "left",
		//         headerAlign: "center",
		//         hideSortIcons: false,
		//         disableColumnMenu: true,
		//         disableReorder: true,
		//         disableExport: true,
		//         maskable: false,
		//         isFixed: true,
		//         isEditable: true,
		//         sequence: 18,
		//         frozenColumn: false,
		//         footer: null,
		//         minWidth: null,
		//         maxWidth: null,
		//         fieldName: null,
		//         edr: "edr",

		//         weekendColumn: null,
		//       },
		//       {
		//         field: "2026-01-15",
		//         headerName: "Thu 15",
		//         description: "2026-01-15",
		//         flex: 1,
		//         hide: false,
		//         hideable: false,
		//         sortable: true,
		//         sortingOrder: "asc",
		//         resizable: false,
		//         type: "number",
		//         align: "left",
		//         headerAlign: "center",
		//         hideSortIcons: false,
		//         disableColumnMenu: true,
		//         disableReorder: true,
		//         disableExport: true,
		//         maskable: false,
		//         isFixed: true,
		//         isEditable: true,
		//         sequence: 19,
		//         frozenColumn: false,
		//         footer: null,
		//         minWidth: null,
		//         maxWidth: null,
		//         fieldName: null,
		//         edr: "edr",

		//         weekendColumn: null,
		//       },
		//       {
		//         field: "total",
		//         headerName: "Total",
		//         description: null,
		//         flex: 1,
		//         hide: false,
		//         hideable: false,
		//         sortable: true,
		//         sortingOrder: "asc",
		//         resizable: false,
		//         type: "string",
		//         align: "left",
		//         headerAlign: "left",
		//         hideSortIcons: false,
		//         disableColumnMenu: true,
		//         disableReorder: true,
		//         disableExport: true,
		//         maskable: false,
		//         isFixed: true,
		//         isEditable: true,
		//         sequence: 20,
		//         frozenColumn: false,
		//         footer: null,
		//         minWidth: null,
		//         maxWidth: null,
		//         fieldName: null,
		//         edr: "edr",

		//         weekendColumn: null,
		//       },
		//     ],
		//   };
		//   return new Promise((resolve) =>
		//     setTimeout(() => resolve(fixedResponse), 1000),
		//   );
		// } else {
		//   // TIMR IN TIMR OUT
		//   const fixedResponseTimeInOut: any = {
		//     page: null,
		//     size: null,
		//     total: null,
		//     items: [
		//       {
		//         description: "123",
		//         project1: "simplepay",
		//         project1Values: [
		//           { label: "SimplePay", value: "simplepay" },
		//           { label: "Taxslips", value: "taxslips" },
		//         ],
		//         location: "",
		//         days: {
		//           "2026-01-01": {
		//             timeIn: null,
		//             timeOut: null,
		//           },
		//           "2026-01-02": {
		//             timeIn: null,
		//             timeOut: null,
		//           },
		//           "2026-01-03": {
		//             timeIn: null,
		//             timeOut: null,
		//           },
		//           "2026-01-04": {
		//             timeIn: null,
		//             timeOut: null,
		//           },
		//           "2026-01-05": {
		//             timeIn: null,
		//             timeOut: null,
		//           },
		//           "2026-01-06": {
		//             timeIn: null,
		//             timeOut: null,
		//           },
		//           "2026-01-07": {
		//             timeIn: null,
		//             timeOut: null,
		//           },
		//           "2026-01-08": {
		//             timeIn: null,
		//             timeOut: null,
		//           },
		//           "2026-01-09": {
		//             timeIn: null,
		//             timeOut: null,
		//           },
		//           "2026-01-10": {
		//             timeIn: null,
		//             timeOut: null,
		//           },
		//           "2026-01-11": {
		//             timeIn: null,
		//             timeOut: null,
		//           },
		//           "2026-01-12": {
		//             timeIn: null,
		//             timeOut: null,
		//           },
		//           "2026-01-13": {
		//             timeIn: null,
		//             timeOut: null,
		//           },
		//           "2026-01-14": {
		//             timeIn: null,
		//             timeOut: null,
		//           },
		//           "2026-01-15": {
		//             timeIn: null,
		//             timeOut: null,
		//           },
		//         },
		//       },
		//       {
		//         description: null,
		//         days: {
		//           "2026-01-01": {
		//             timeIn: null,
		//             timeOut: null,
		//           },
		//           "2026-01-02": {
		//             timeIn: null,
		//             timeOut: null,
		//           },
		//           "2026-01-03": {
		//             timeIn: null,
		//             timeOut: null,
		//           },
		//           "2026-01-04": {
		//             timeIn: null,
		//             timeOut: null,
		//           },
		//           "2026-01-05": {
		//             timeIn: null,
		//             timeOut: null,
		//           },
		//           "2026-01-06": {
		//             timeIn: null,
		//             timeOut: null,
		//           },
		//           "2026-01-07": {
		//             timeIn: null,
		//             timeOut: null,
		//           },
		//           "2026-01-08": {
		//             timeIn: null,
		//             timeOut: null,
		//           },
		//           "2026-01-09": {
		//             timeIn: null,
		//             timeOut: null,
		//           },
		//           "2026-01-10": {
		//             timeIn: null,
		//             timeOut: null,
		//           },
		//           "2026-01-11": {
		//             timeIn: null,
		//             timeOut: null,
		//           },
		//           "2026-01-12": {
		//             timeIn: null,
		//             timeOut: null,
		//           },
		//           "2026-01-13": {
		//             timeIn: null,
		//             timeOut: null,
		//           },
		//           "2026-01-14": {
		//             timeIn: null,
		//             timeOut: null,
		//           },
		//           "2026-01-15": {
		//             timeIn: null,
		//             timeOut: null,
		//           },
		//         },
		//       },
		//       {
		//         description: null,
		//         days: {
		//           "2026-01-01": {
		//             timeIn: null,
		//             timeOut: null,
		//           },
		//           "2026-01-02": {
		//             timeIn: null,
		//             timeOut: null,
		//           },
		//           "2026-01-03": {
		//             timeIn: null,
		//             timeOut: null,
		//           },
		//           "2026-01-04": {
		//             timeIn: null,
		//             timeOut: null,
		//           },
		//           "2026-01-05": {
		//             timeIn: null,
		//             timeOut: null,
		//           },
		//           "2026-01-06": {
		//             timeIn: null,
		//             timeOut: null,
		//           },
		//           "2026-01-07": {
		//             timeIn: null,
		//             timeOut: null,
		//           },
		//           "2026-01-08": {
		//             timeIn: null,
		//             timeOut: null,
		//           },
		//           "2026-01-09": {
		//             timeIn: null,
		//             timeOut: null,
		//           },
		//           "2026-01-10": {
		//             timeIn: null,
		//             timeOut: null,
		//           },
		//           "2026-01-11": {
		//             timeIn: null,
		//             timeOut: null,
		//           },
		//           "2026-01-12": {
		//             timeIn: null,
		//             timeOut: null,
		//           },
		//           "2026-01-13": {
		//             timeIn: null,
		//             timeOut: null,
		//           },
		//           "2026-01-14": {
		//             timeIn: null,
		//             timeOut: null,
		//           },
		//           "2026-01-15": {
		//             timeIn: null,
		//             timeOut: null,
		//           },
		//         },
		//       },
		//       {
		//         description: null,
		//         days: {
		//           "2026-01-01": {
		//             timeIn: null,
		//             timeOut: null,
		//           },
		//           "2026-01-02": {
		//             timeIn: null,
		//             timeOut: null,
		//           },
		//           "2026-01-03": {
		//             timeIn: null,
		//             timeOut: null,
		//           },
		//           "2026-01-04": {
		//             timeIn: null,
		//             timeOut: null,
		//           },
		//           "2026-01-05": {
		//             timeIn: null,
		//             timeOut: null,
		//           },
		//           "2026-01-06": {
		//             timeIn: null,
		//             timeOut: null,
		//           },
		//           "2026-01-07": {
		//             timeIn: null,
		//             timeOut: null,
		//           },
		//           "2026-01-08": {
		//             timeIn: null,
		//             timeOut: null,
		//           },
		//           "2026-01-09": {
		//             timeIn: null,
		//             timeOut: null,
		//           },
		//           "2026-01-10": {
		//             timeIn: null,
		//             timeOut: null,
		//           },
		//           "2026-01-11": {
		//             timeIn: null,
		//             timeOut: null,
		//           },
		//           "2026-01-12": {
		//             timeIn: null,
		//             timeOut: null,
		//           },
		//           "2026-01-13": {
		//             timeIn: null,
		//             timeOut: null,
		//           },
		//           "2026-01-14": {
		//             timeIn: null,
		//             timeOut: null,
		//           },
		//           "2026-01-15": {
		//             timeIn: null,
		//             timeOut: null,
		//           },
		//         },
		//       },
		//       {
		//         description: null,
		//         days: {
		//           "2026-01-01": {
		//             timeIn: null,
		//             timeOut: null,
		//           },
		//           "2026-01-02": {
		//             timeIn: null,
		//             timeOut: null,
		//           },
		//           "2026-01-03": {
		//             timeIn: null,
		//             timeOut: null,
		//           },
		//           "2026-01-04": {
		//             timeIn: null,
		//             timeOut: null,
		//           },
		//           "2026-01-05": {
		//             timeIn: null,
		//             timeOut: null,
		//           },
		//           "2026-01-06": {
		//             timeIn: null,
		//             timeOut: null,
		//           },
		//           "2026-01-07": {
		//             timeIn: null,
		//             timeOut: null,
		//           },
		//           "2026-01-08": {
		//             timeIn: null,
		//             timeOut: null,
		//           },
		//           "2026-01-09": {
		//             timeIn: null,
		//             timeOut: null,
		//           },
		//           "2026-01-10": {
		//             timeIn: null,
		//             timeOut: null,
		//           },
		//           "2026-01-11": {
		//             timeIn: null,
		//             timeOut: null,
		//           },
		//           "2026-01-12": {
		//             timeIn: null,
		//             timeOut: null,
		//           },
		//           "2026-01-13": {
		//             timeIn: null,
		//             timeOut: null,
		//           },
		//           "2026-01-14": {
		//             timeIn: null,
		//             timeOut: null,
		//           },
		//           "2026-01-15": {
		//             timeIn: null,
		//             timeOut: null,
		//           },
		//         },
		//       },
		//     ],
		//     keyField: null,
		//     headerColumns: [
		//       {
		//         field: "project1",
		//         headerName: "Project 1",
		//         description: null,
		//         flex: 1,
		//         hide: false,
		//         hideable: false,
		//         sortable: true,
		//         sortingOrder: "asc",
		//         resizable: false,
		//         type: "dropdown",
		//         align: "left",
		//         headerAlign: "left",
		//         hideSortIcons: false,
		//         disableColumnMenu: true,
		//         disableReorder: true,
		//         disableExport: true,
		//         maskable: false,
		//         isFixed: true,
		//         isEditable: true,
		//         sequence: 1,
		//         frozenColumn: false,
		//         footer: null,
		//         minWidth: null,
		//         maxWidth: null,
		//         fieldName: null,
		//         edr: "edr",

		//         parentHeaderName: null,
		//         weekendColumn: null,
		//       },
		//       {
		//         field: "location",
		//         headerName: "Location",
		//         description: null,
		//         flex: 1,
		//         hide: false,
		//         hideable: false,
		//         sortable: true,
		//         sortingOrder: "asc",
		//         resizable: false,
		//         type: "text",
		//         align: "left",
		//         headerAlign: "left",
		//         hideSortIcons: false,
		//         disableColumnMenu: true,
		//         disableReorder: true,
		//         disableExport: true,
		//         maskable: false,
		//         isFixed: true,
		//         isEditable: true,
		//         sequence: 2,
		//         frozenColumn: false,
		//         footer: null,
		//         minWidth: null,
		//         maxWidth: null,
		//         fieldName: null,
		//         edr: "edr",

		//         parentHeaderName: null,
		//         weekendColumn: null,
		//       },
		//       {
		//         field: "description",
		//         headerName: "Description",
		//         description: null,
		//         flex: 1,
		//         hide: false,
		//         hideable: false,
		//         sortable: true,
		//         sortingOrder: "asc",
		//         resizable: false,
		//         type: "text",
		//         align: "left",
		//         headerAlign: "left",
		//         hideSortIcons: false,
		//         disableColumnMenu: true,
		//         disableReorder: true,
		//         disableExport: true,
		//         maskable: false,
		//         isFixed: true,
		//         isEditable: true,
		//         sequence: 4,
		//         frozenColumn: false,
		//         footer: null,
		//         minWidth: null,
		//         maxWidth: null,
		//         fieldName: null,
		//         edr: "edr",

		//         parentHeaderName: null,
		//         weekendColumn: null,
		//       },

		//       // 2026-01-01
		//       {
		//         field: "days.2026-01-01.timeIn",
		//         headerName: "In",
		//         description: "2026-01-01",
		//         flex: 1,
		//         hide: false,
		//         hideable: false,
		//         sortable: true,
		//         sortingOrder: "asc",
		//         resizable: false,
		//         type: "number",
		//         align: "left",
		//         headerAlign: "center",
		//         hideSortIcons: false,
		//         disableColumnMenu: true,
		//         disableReorder: true,
		//         disableExport: true,
		//         maskable: false,
		//         isFixed: true,
		//         isEditable: true,
		//         sequence: 5,
		//         frozenColumn: false,
		//         footer: null,
		//         minWidth: null,
		//         maxWidth: null,
		//         fieldName: null,
		//         edr: "edr",

		//         parentHeaderName: "Sun 1",
		//         weekendColumn: true,
		//       },
		//       {
		//         field: "days.2026-01-01.timeOut",
		//         headerName: "Out",
		//         description: "2026-01-01",
		//         flex: 1,
		//         hide: false,
		//         hideable: false,
		//         sortable: true,
		//         sortingOrder: "asc",
		//         resizable: false,
		//         type: "number",
		//         align: "left",
		//         headerAlign: "center",
		//         hideSortIcons: false,
		//         disableColumnMenu: true,
		//         disableReorder: true,
		//         disableExport: true,
		//         maskable: false,
		//         isFixed: true,
		//         isEditable: true,
		//         sequence: 5,
		//         frozenColumn: false,
		//         footer: null,
		//         minWidth: null,
		//         maxWidth: null,
		//         fieldName: null,
		//         edr: "edr",

		//         parentHeaderName: "",
		//         weekendColumn: true,
		//       },

		//       // 2026-01-02
		//       {
		//         field: "days.2026-01-02.timeIn",
		//         headerName: "In",
		//         description: "2026-01-02",
		//         flex: 1,
		//         hide: false,
		//         hideable: false,
		//         sortable: true,
		//         sortingOrder: "asc",
		//         resizable: false,
		//         type: "number",
		//         align: "left",
		//         headerAlign: "center",
		//         hideSortIcons: false,
		//         disableColumnMenu: true,
		//         disableReorder: true,
		//         disableExport: true,
		//         maskable: false,
		//         isFixed: true,
		//         isEditable: true,
		//         sequence: 6,
		//         frozenColumn: false,
		//         footer: null,
		//         minWidth: null,
		//         maxWidth: null,
		//         fieldName: null,
		//         edr: "edr",

		//         parentHeaderName: "Mon 2",
		//         weekendColumn: null,
		//       },
		//       {
		//         field: "days.2026-01-02.timeOut",
		//         headerName: "Out",
		//         description: "2026-01-02",
		//         flex: 1,
		//         hide: false,
		//         hideable: false,
		//         sortable: true,
		//         sortingOrder: "asc",
		//         resizable: false,
		//         type: "number",
		//         align: "left",
		//         headerAlign: "center",
		//         hideSortIcons: false,
		//         disableColumnMenu: true,
		//         disableReorder: true,
		//         disableExport: true,
		//         maskable: false,
		//         isFixed: true,
		//         isEditable: true,
		//         sequence: 6,
		//         frozenColumn: false,
		//         footer: null,
		//         minWidth: null,
		//         maxWidth: null,
		//         fieldName: null,
		//         edr: "edr",

		//         parentHeaderName: "",
		//         weekendColumn: null,
		//       },

		//       // 2026-01-03
		//       {
		//         field: "days.2026-01-03.timeIn",
		//         headerName: "In",
		//         description: "2026-01-03",
		//         flex: 1,
		//         hide: false,
		//         hideable: false,
		//         sortable: true,
		//         sortingOrder: "asc",
		//         resizable: false,
		//         type: "number",
		//         align: "left",
		//         headerAlign: "center",
		//         hideSortIcons: false,
		//         disableColumnMenu: true,
		//         disableReorder: true,
		//         disableExport: true,
		//         maskable: false,
		//         isFixed: true,
		//         isEditable: true,
		//         sequence: 7,
		//         frozenColumn: false,
		//         footer: null,
		//         minWidth: null,
		//         maxWidth: null,
		//         fieldName: null,
		//         edr: "edr",

		//         parentHeaderName: "Tue 3",
		//         weekendColumn: null,
		//       },
		//       {
		//         field: "days.2026-01-03.timeOut",
		//         headerName: "Out",
		//         description: "2026-01-03",
		//         flex: 1,
		//         hide: false,
		//         hideable: false,
		//         sortable: true,
		//         sortingOrder: "asc",
		//         resizable: false,
		//         type: "number",
		//         align: "left",
		//         headerAlign: "center",
		//         hideSortIcons: false,
		//         disableColumnMenu: true,
		//         disableReorder: true,
		//         disableExport: true,
		//         maskable: false,
		//         isFixed: true,
		//         isEditable: true,
		//         sequence: 7,
		//         frozenColumn: false,
		//         footer: null,
		//         minWidth: null,
		//         maxWidth: null,
		//         fieldName: null,
		//         edr: "edr",

		//         parentHeaderName: "",
		//         weekendColumn: null,
		//       },

		//       // 2026-01-04
		//       {
		//         field: "days.2026-01-04.timeIn",
		//         headerName: "In",
		//         description: "2026-01-04",
		//         flex: 1,
		//         hide: false,
		//         hideable: false,
		//         sortable: true,
		//         sortingOrder: "asc",
		//         resizable: false,
		//         type: "number",
		//         align: "left",
		//         headerAlign: "center",
		//         hideSortIcons: false,
		//         disableColumnMenu: true,
		//         disableReorder: true,
		//         disableExport: true,
		//         maskable: false,
		//         isFixed: true,
		//         isEditable: true,
		//         sequence: 8,
		//         frozenColumn: false,
		//         footer: null,
		//         minWidth: null,
		//         maxWidth: null,
		//         fieldName: null,
		//         edr: "edr",

		//         parentHeaderName: "Wed 4",
		//         weekendColumn: null,
		//       },
		//       {
		//         field: "days.2026-01-04.timeOut",
		//         headerName: "Out",
		//         description: "2026-01-04",
		//         flex: 1,
		//         hide: false,
		//         hideable: false,
		//         sortable: true,
		//         sortingOrder: "asc",
		//         resizable: false,
		//         type: "number",
		//         align: "left",
		//         headerAlign: "center",
		//         hideSortIcons: false,
		//         disableColumnMenu: true,
		//         disableReorder: true,
		//         disableExport: true,
		//         maskable: false,
		//         isFixed: true,
		//         isEditable: true,
		//         sequence: 8,
		//         frozenColumn: false,
		//         footer: null,
		//         minWidth: null,
		//         maxWidth: null,
		//         fieldName: null,
		//         edr: "edr",

		//         parentHeaderName: "",
		//         weekendColumn: null,
		//       },

		//       // 2026-01-05
		//       {
		//         field: "days.2026-01-05.timeIn",
		//         headerName: "In",
		//         description: "2026-01-05",
		//         flex: 1,
		//         hide: false,
		//         hideable: false,
		//         sortable: true,
		//         sortingOrder: "asc",
		//         resizable: false,
		//         type: "number",
		//         align: "left",
		//         headerAlign: "center",
		//         hideSortIcons: false,
		//         disableColumnMenu: true,
		//         disableReorder: true,
		//         disableExport: true,
		//         maskable: false,
		//         isFixed: true,
		//         isEditable: true,
		//         sequence: 9,
		//         frozenColumn: false,
		//         footer: null,
		//         minWidth: null,
		//         maxWidth: null,
		//         fieldName: null,
		//         edr: "edr",

		//         parentHeaderName: "Thu 5",
		//         weekendColumn: null,
		//       },
		//       {
		//         field: "days.2026-01-05.timeOut",
		//         headerName: "Out",
		//         description: "2026-01-05",
		//         flex: 1,
		//         hide: false,
		//         hideable: false,
		//         sortable: true,
		//         sortingOrder: "asc",
		//         resizable: false,
		//         type: "number",
		//         align: "left",
		//         headerAlign: "center",
		//         hideSortIcons: false,
		//         disableColumnMenu: true,
		//         disableReorder: true,
		//         disableExport: true,
		//         maskable: false,
		//         isFixed: true,
		//         isEditable: true,
		//         sequence: 9,
		//         frozenColumn: false,
		//         footer: null,
		//         minWidth: null,
		//         maxWidth: null,
		//         fieldName: null,
		//         edr: "edr",

		//         parentHeaderName: "",
		//         weekendColumn: null,
		//       },

		//       // 2026-01-06
		//       {
		//         field: "days.2026-01-06.timeIn",
		//         headerName: "In",
		//         description: "2026-01-06",
		//         flex: 1,
		//         hide: false,
		//         hideable: false,
		//         sortable: true,
		//         sortingOrder: "asc",
		//         resizable: false,
		//         type: "number",
		//         align: "left",
		//         headerAlign: "center",
		//         hideSortIcons: false,
		//         disableColumnMenu: true,
		//         disableReorder: true,
		//         disableExport: true,
		//         maskable: false,
		//         isFixed: true,
		//         isEditable: true,
		//         sequence: 10,
		//         frozenColumn: false,
		//         footer: null,
		//         minWidth: null,
		//         maxWidth: null,
		//         fieldName: null,
		//         edr: "edr",

		//         parentHeaderName: "Fri 6",
		//         weekendColumn: null,
		//       },
		//       {
		//         field: "days.2026-01-06.timeOut",
		//         headerName: "Out",
		//         description: "2026-01-06",
		//         flex: 1,
		//         hide: false,
		//         hideable: false,
		//         sortable: true,
		//         sortingOrder: "asc",
		//         resizable: false,
		//         type: "number",
		//         align: "left",
		//         headerAlign: "center",
		//         hideSortIcons: false,
		//         disableColumnMenu: true,
		//         disableReorder: true,
		//         disableExport: true,
		//         maskable: false,
		//         isFixed: true,
		//         isEditable: true,
		//         sequence: 10,
		//         frozenColumn: false,
		//         footer: null,
		//         minWidth: null,
		//         maxWidth: null,
		//         fieldName: null,
		//         edr: "edr",

		//         parentHeaderName: "",
		//         weekendColumn: null,
		//       },

		//       // 2026-01-07
		//       {
		//         field: "days.2026-01-07.timeIn",
		//         headerName: "In",
		//         description: "2026-01-07",
		//         flex: 1,
		//         hide: false,
		//         hideable: false,
		//         sortable: true,
		//         sortingOrder: "asc",
		//         resizable: false,
		//         type: "number",
		//         align: "left",
		//         headerAlign: "center",
		//         hideSortIcons: false,
		//         disableColumnMenu: true,
		//         disableReorder: true,
		//         disableExport: true,
		//         maskable: false,
		//         isFixed: true,
		//         isEditable: true,
		//         sequence: 11,
		//         frozenColumn: false,
		//         footer: null,
		//         minWidth: null,
		//         maxWidth: null,
		//         fieldName: null,
		//         edr: "edr",

		//         parentHeaderName: "Sat 7",
		//         weekendColumn: true,
		//       },
		//       {
		//         field: "days.2026-01-07.timeOut",
		//         headerName: "Out",
		//         description: "2026-01-07",
		//         flex: 1,
		//         hide: false,
		//         hideable: false,
		//         sortable: true,
		//         sortingOrder: "asc",
		//         resizable: false,
		//         type: "number",
		//         align: "left",
		//         headerAlign: "center",
		//         hideSortIcons: false,
		//         disableColumnMenu: true,
		//         disableReorder: true,
		//         disableExport: true,
		//         maskable: false,
		//         isFixed: true,
		//         isEditable: true,
		//         sequence: 11,
		//         frozenColumn: false,
		//         footer: null,
		//         minWidth: null,
		//         maxWidth: null,
		//         fieldName: null,
		//         edr: "edr",

		//         parentHeaderName: "",
		//         weekendColumn: true,
		//       },

		//       // 2026-01-08
		//       {
		//         field: "days.2026-01-08.timeIn",
		//         headerName: "In",
		//         description: "2026-01-08",
		//         flex: 1,
		//         hide: false,
		//         hideable: false,
		//         sortable: true,
		//         sortingOrder: "asc",
		//         resizable: false,
		//         type: "number",
		//         align: "left",
		//         headerAlign: "center",
		//         hideSortIcons: false,
		//         disableColumnMenu: true,
		//         disableReorder: true,
		//         disableExport: true,
		//         maskable: false,
		//         isFixed: true,
		//         isEditable: true,
		//         sequence: 12,
		//         frozenColumn: false,
		//         footer: null,
		//         minWidth: null,
		//         maxWidth: null,
		//         fieldName: null,
		//         edr: "edr",

		//         parentHeaderName: "Sun 8",
		//         weekendColumn: true,
		//       },
		//       {
		//         field: "days.2026-01-08.timeOut",
		//         headerName: "Out",
		//         description: "2026-01-08",
		//         flex: 1,
		//         hide: false,
		//         hideable: false,
		//         sortable: true,
		//         sortingOrder: "asc",
		//         resizable: false,
		//         type: "number",
		//         align: "left",
		//         headerAlign: "center",
		//         hideSortIcons: false,
		//         disableColumnMenu: true,
		//         disableReorder: true,
		//         disableExport: true,
		//         maskable: false,
		//         isFixed: true,
		//         isEditable: true,
		//         sequence: 12,
		//         frozenColumn: false,
		//         footer: null,
		//         minWidth: null,
		//         maxWidth: null,
		//         fieldName: null,
		//         edr: "edr",

		//         parentHeaderName: "",
		//         weekendColumn: true,
		//       },

		//       // 2026-01-09
		//       {
		//         field: "days.2026-01-09.timeIn",
		//         headerName: "In",
		//         description: "2026-01-09",
		//         flex: 1,
		//         hide: false,
		//         hideable: false,
		//         sortable: true,
		//         sortingOrder: "asc",
		//         resizable: false,
		//         type: "number",
		//         align: "left",
		//         headerAlign: "center",
		//         hideSortIcons: false,
		//         disableColumnMenu: true,
		//         disableReorder: true,
		//         disableExport: true,
		//         maskable: false,
		//         isFixed: true,
		//         isEditable: true,
		//         sequence: 13,
		//         frozenColumn: false,
		//         footer: null,
		//         minWidth: null,
		//         maxWidth: null,
		//         fieldName: null,
		//         edr: "edr",

		//         parentHeaderName: "Mon 9",
		//         weekendColumn: null,
		//       },
		//       {
		//         field: "days.2026-01-09.timeOut",
		//         headerName: "Out",
		//         description: "2026-01-09",
		//         flex: 1,
		//         hide: false,
		//         hideable: false,
		//         sortable: true,
		//         sortingOrder: "asc",
		//         resizable: false,
		//         type: "number",
		//         align: "left",
		//         headerAlign: "center",
		//         hideSortIcons: false,
		//         disableColumnMenu: true,
		//         disableReorder: true,
		//         disableExport: true,
		//         maskable: false,
		//         isFixed: true,
		//         isEditable: true,
		//         sequence: 13,
		//         frozenColumn: false,
		//         footer: null,
		//         minWidth: null,
		//         maxWidth: null,
		//         fieldName: null,
		//         edr: "edr",

		//         parentHeaderName: "",
		//         weekendColumn: null,
		//       },

		//       // 2026-01-10
		//       {
		//         field: "days.2026-01-10.timeIn",
		//         headerName: "In",
		//         description: "2026-01-10",
		//         flex: 1,
		//         hide: false,
		//         hideable: false,
		//         sortable: true,
		//         sortingOrder: "asc",
		//         resizable: false,
		//         type: "number",
		//         align: "left",
		//         headerAlign: "center",
		//         hideSortIcons: false,
		//         disableColumnMenu: true,
		//         disableReorder: true,
		//         disableExport: true,
		//         maskable: false,
		//         isFixed: true,
		//         isEditable: true,
		//         sequence: 14,
		//         frozenColumn: false,
		//         footer: null,
		//         minWidth: null,
		//         maxWidth: null,
		//         fieldName: null,
		//         edr: "edr",

		//         parentHeaderName: "Tue 10",
		//         weekendColumn: null,
		//       },
		//       {
		//         field: "days.2026-01-10.timeOut",
		//         headerName: "Out",
		//         description: "2026-01-10",
		//         flex: 1,
		//         hide: false,
		//         hideable: false,
		//         sortable: true,
		//         sortingOrder: "asc",
		//         resizable: false,
		//         type: "number",
		//         align: "left",
		//         headerAlign: "center",
		//         hideSortIcons: false,
		//         disableColumnMenu: true,
		//         disableReorder: true,
		//         disableExport: true,
		//         maskable: false,
		//         isFixed: true,
		//         isEditable: true,
		//         sequence: 14,
		//         frozenColumn: false,
		//         footer: null,
		//         minWidth: null,
		//         maxWidth: null,
		//         fieldName: null,
		//         edr: "edr",

		//         parentHeaderName: "",
		//         weekendColumn: null,
		//       },

		//       // 2026-01-11
		//       {
		//         field: "days.2026-01-11.timeIn",
		//         headerName: "In",
		//         description: "2026-01-11",
		//         flex: 1,
		//         hide: false,
		//         hideable: false,
		//         sortable: true,
		//         sortingOrder: "asc",
		//         resizable: false,
		//         type: "number",
		//         align: "left",
		//         headerAlign: "center",
		//         hideSortIcons: false,
		//         disableColumnMenu: true,
		//         disableReorder: true,
		//         disableExport: true,
		//         maskable: false,
		//         isFixed: true,
		//         isEditable: true,
		//         sequence: 15,
		//         frozenColumn: false,
		//         footer: null,
		//         minWidth: null,
		//         maxWidth: null,
		//         fieldName: null,
		//         edr: "edr",

		//         parentHeaderName: "Wed 11",
		//         weekendColumn: null,
		//       },
		//       {
		//         field: "days.2026-01-11.timeOut",
		//         headerName: "Out",
		//         description: "2026-01-11",
		//         flex: 1,
		//         hide: false,
		//         hideable: false,
		//         sortable: true,
		//         sortingOrder: "asc",
		//         resizable: false,
		//         type: "number",
		//         align: "left",
		//         headerAlign: "center",
		//         hideSortIcons: false,
		//         disableColumnMenu: true,
		//         disableReorder: true,
		//         disableExport: true,
		//         maskable: false,
		//         isFixed: true,
		//         isEditable: true,
		//         sequence: 15,
		//         frozenColumn: false,
		//         footer: null,
		//         minWidth: null,
		//         maxWidth: null,
		//         fieldName: null,
		//         edr: "edr",

		//         parentHeaderName: "",
		//         weekendColumn: null,
		//       },

		//       // 2026-01-12
		//       {
		//         field: "days.2026-01-12.timeIn",
		//         headerName: "In",
		//         description: "2026-01-12",
		//         flex: 1,
		//         hide: false,
		//         hideable: false,
		//         sortable: true,
		//         sortingOrder: "asc",
		//         resizable: false,
		//         type: "number",
		//         align: "left",
		//         headerAlign: "center",
		//         hideSortIcons: false,
		//         disableColumnMenu: true,
		//         disableReorder: true,
		//         disableExport: true,
		//         maskable: false,
		//         isFixed: true,
		//         isEditable: true,
		//         sequence: 16,
		//         frozenColumn: false,
		//         footer: null,
		//         minWidth: null,
		//         maxWidth: null,
		//         fieldName: null,
		//         edr: "edr",

		//         parentHeaderName: "Thu 12",
		//         weekendColumn: null,
		//       },
		//       {
		//         field: "days.2026-01-12.timeOut",
		//         headerName: "Out",
		//         description: "2026-01-12",
		//         flex: 1,
		//         hide: false,
		//         hideable: false,
		//         sortable: true,
		//         sortingOrder: "asc",
		//         resizable: false,
		//         type: "number",
		//         align: "left",
		//         headerAlign: "center",
		//         hideSortIcons: false,
		//         disableColumnMenu: true,
		//         disableReorder: true,
		//         disableExport: true,
		//         maskable: false,
		//         isFixed: true,
		//         isEditable: true,
		//         sequence: 16,
		//         frozenColumn: false,
		//         footer: null,
		//         minWidth: null,
		//         maxWidth: null,
		//         fieldName: null,
		//         edr: "edr",

		//         parentHeaderName: "",
		//         weekendColumn: null,
		//       },

		//       // 2026-01-13
		//       {
		//         field: "days.2026-01-13.timeIn",
		//         headerName: "In",
		//         description: "2026-01-13",
		//         flex: 1,
		//         hide: false,
		//         hideable: false,
		//         sortable: true,
		//         sortingOrder: "asc",
		//         resizable: false,
		//         type: "number",
		//         align: "left",
		//         headerAlign: "center",
		//         hideSortIcons: false,
		//         disableColumnMenu: true,
		//         disableReorder: true,
		//         disableExport: true,
		//         maskable: false,
		//         isFixed: true,
		//         isEditable: true,
		//         sequence: 17,
		//         frozenColumn: false,
		//         footer: null,
		//         minWidth: null,
		//         maxWidth: null,
		//         fieldName: null,
		//         edr: "edr",

		//         parentHeaderName: "Fri 13",
		//         weekendColumn: null,
		//       },
		//       {
		//         field: "days.2026-01-13.timeOut",
		//         headerName: "Out",
		//         description: "2026-01-13",
		//         flex: 1,
		//         hide: false,
		//         hideable: false,
		//         sortable: true,
		//         sortingOrder: "asc",
		//         resizable: false,
		//         type: "number",
		//         align: "left",
		//         headerAlign: "center",
		//         hideSortIcons: false,
		//         disableColumnMenu: true,
		//         disableReorder: true,
		//         disableExport: true,
		//         maskable: false,
		//         isFixed: true,
		//         isEditable: true,
		//         sequence: 17,
		//         frozenColumn: false,
		//         footer: null,
		//         minWidth: null,
		//         maxWidth: null,
		//         fieldName: null,
		//         edr: "edr",

		//         parentHeaderName: "",
		//         weekendColumn: null,
		//       },

		//       // 2026-01-14
		//       {
		//         field: "days.2026-01-14.timeIn",
		//         headerName: "In",
		//         description: "2026-01-14",
		//         flex: 1,
		//         hide: false,
		//         hideable: false,
		//         sortable: true,
		//         sortingOrder: "asc",
		//         resizable: false,
		//         type: "number",
		//         align: "left",
		//         headerAlign: "center",
		//         hideSortIcons: false,
		//         disableColumnMenu: true,
		//         disableReorder: true,
		//         disableExport: true,
		//         maskable: false,
		//         isFixed: true,
		//         isEditable: true,
		//         sequence: 18,
		//         frozenColumn: false,
		//         footer: null,
		//         minWidth: null,
		//         maxWidth: null,
		//         fieldName: null,
		//         edr: "edr",

		//         parentHeaderName: "Sat 14",
		//         weekendColumn: true,
		//       },
		//       {
		//         field: "days.2026-01-14.timeOut",
		//         headerName: "Out",
		//         description: "2026-01-14",
		//         flex: 1,
		//         hide: false,
		//         hideable: false,
		//         sortable: true,
		//         sortingOrder: "asc",
		//         resizable: false,
		//         type: "number",
		//         align: "left",
		//         headerAlign: "center",
		//         hideSortIcons: false,
		//         disableColumnMenu: true,
		//         disableReorder: true,
		//         disableExport: true,
		//         maskable: false,
		//         isFixed: true,
		//         isEditable: true,
		//         sequence: 18,
		//         frozenColumn: false,
		//         footer: null,
		//         minWidth: null,
		//         maxWidth: null,
		//         fieldName: null,
		//         edr: "edr",

		//         parentHeaderName: "",
		//         weekendColumn: true,
		//       },

		//       // 2026-01-15
		//       {
		//         field: "days.2026-01-15.timeIn",
		//         headerName: "In",
		//         description: "2026-01-15",
		//         flex: 1,
		//         hide: false,
		//         hideable: false,
		//         sortable: true,
		//         sortingOrder: "asc",
		//         resizable: false,
		//         type: "number",
		//         align: "left",
		//         headerAlign: "center",
		//         hideSortIcons: false,
		//         disableColumnMenu: true,
		//         disableReorder: true,
		//         disableExport: true,
		//         maskable: false,
		//         isFixed: true,
		//         isEditable: true,
		//         sequence: 19,
		//         frozenColumn: false,
		//         footer: null,
		//         minWidth: null,
		//         maxWidth: null,
		//         fieldName: null,
		//         edr: "edr",

		//         parentHeaderName: "Sun 15",
		//         weekendColumn: true,
		//       },
		//       {
		//         field: "days.2026-01-15.timeOut",
		//         headerName: "Out",
		//         description: "2026-01-15",
		//         flex: 1,
		//         hide: false,
		//         hideable: false,
		//         sortable: true,
		//         sortingOrder: "asc",
		//         resizable: false,
		//         type: "number",
		//         align: "left",
		//         headerAlign: "center",
		//         hideSortIcons: false,
		//         disableColumnMenu: true,
		//         disableReorder: true,
		//         disableExport: true,
		//         maskable: false,
		//         isFixed: true,
		//         isEditable: true,
		//         sequence: 19,
		//         frozenColumn: false,
		//         footer: null,
		//         minWidth: null,
		//         maxWidth: null,
		//         fieldName: null,
		//         edr: "edr",

		//         parentHeaderName: "",
		//         weekendColumn: true,
		//       },

		//       // total
		//       {
		//         field: "total",
		//         headerName: "Total",
		//         description: null,
		//         flex: 1,
		//         hide: false,
		//         hideable: false,
		//         sortable: true,
		//         sortingOrder: "asc",
		//         resizable: false,
		//         type: "string",
		//         align: "left",
		//         headerAlign: "left",
		//         hideSortIcons: false,
		//         disableColumnMenu: true,
		//         disableReorder: true,
		//         disableExport: true,
		//         maskable: false,
		//         isFixed: true,
		//         isEditable: true,
		//         sequence: 20,
		//         frozenColumn: false,
		//         footer: null,
		//         minWidth: null,
		//         maxWidth: null,
		//         fieldName: null,
		//         edr: "edr",

		//         parentHeaderName: null,
		//         weekendColumn: null,
		//       },
		//     ],
		//   };
		//   return new Promise((resolve) =>
		//     setTimeout(() => resolve(fixedResponseTimeInOut), 1000),
		//   );
		// }
	},
	createPayrollTimeSheet: async (
		requestPayload: any,
	): Promise<IPayroll | IServerError | IResponse | any> => {
		try {
			const response: AxiosResponse<IPayroll> = await http.post<IPayroll>(
				"/v1/time-sheet/",
				requestPayload,
			);

			if (response.status === 201) {
				return response;
			} else if (response.status === 400) {
				return response.data;
			} else if (response.status === 401) {
				// window.location.href = '/logout';
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				requestPayload.navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else if (axiosError && axiosError.status === 422) {
				return {
					status: false,
					message: `Errors : \n${format422Errors(axiosError?.response?.data)}`,
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},
	saveAndCalculatePayrollTimeSheet: async (
		requestPayload: any,
	): Promise<IPayroll | IServerError | IResponse | any> => {
		try {
			const response: AxiosResponse<IPayroll> = await http.post<IPayroll>(
				"/v1/payroll-timesheet/",
				requestPayload.data,
			);

			if (response.status === 201) {
				return response;
			} else if (response.status === 400) {
				return response.data;
			} else if (response.status === 401) {
				// window.location.href = '/logout';
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				requestPayload.navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else if (axiosError && axiosError.status === 422) {
				return {
					status: false,
					message: `Errors : \n${format422Errors(axiosError?.response?.data)}`,
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},
	deletePayrollTimeSheetData: async (
		delEmployeePayrollDataPayload: any,
	): Promise<string | IServerError | IResponse | any> => {
		try {
			const response: AxiosResponse<IPayroll> = await http.delete<IPayroll>(
				`/v1/time-sheet/{id}/?client_id=${delEmployeePayrollDataPayload.clientId}&employee_id=${delEmployeePayrollDataPayload.employeeId}&pay_period_start_date=${delEmployeePayrollDataPayload.payPeriodStartDate}&pay_period_end_date=${delEmployeePayrollDataPayload.payPeriodEndDate}&work_format=${delEmployeePayrollDataPayload.workFormat}&input_hours=${delEmployeePayrollDataPayload.inputHours}&payroll_shedule_id=${delEmployeePayrollDataPayload.payrollScheduleId}`,
				// delEmployeePayrollDataPayload.data,
			);

			if (response.status === 200) {
				return "Record has been deleted successfully.";
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				delEmployeePayrollDataPayload.navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},
	createTimeSheetCategories: async (
		requestPayload: any,
	): Promise<ITimeSheetCategories | IServerError | IResponse | any> => {
		if (requestPayload.clientId) {
			try {
				const response: AxiosResponse<ITimeSheetCategories> =
					await http.put<ITimeSheetCategories>(
						`/v1/time-sheet-categories/${requestPayload.clientId}/`,
						requestPayload,
					);

				if (response.status === 200) {
					return response;
				} else if (response.status === 400) {
					return response.data;
				} else if (response.status === 500) {
					return {
						status: false,
						message: "Something went wrong.",
						error: true,
					};
				}
			} catch (error) {
				const axiosError = error as AxiosError;
				console.error("An error occurred:", axiosError);
				const errorMessage =
					axiosError.response && typeof axiosError.response.data === "string"
						? axiosError.response.data
						: "Unknown error";
				if (axiosError && axiosError.status === 401) {
					requestPayload.navigateToLogout("/logout");
					return {
						status: false,
						message: "UnAuthrized",
					};
				} else {
					return {
						status: false,
						message: errorMessage,
					};
				}
			}
		}

		try {
			const response: AxiosResponse<ITimeSheetCategories> =
				await http.post<ITimeSheetCategories>(
					`/v1/time-sheet-categories/`,
					requestPayload,
				);

			if (response.status === 201) {
				return response;
			} else if (response.status === 400) {
				return response.data;
			} else if (response.status === 401) {
				// window.location.href = '/logout';
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				requestPayload.navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},

	getTimeSheetCategoriesById: async (
		// id: string | undefined,
		clientId: string,
		navigateToLogout: (path: string) => void,
	): Promise<
		ITimeSheetCategoryTracking | IServerError | IResponse | null | any
	> => {
		// if (!clientId) return null;
		try {
			const response: AxiosResponse<ITimeSheetCategoryTracking> =
				await http.get<ITimeSheetCategoryTracking>(
					`/v1/time-sheet-categories/${clientId}/`,
				);

			if (response.status === 200) {
				return response.data;
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},

	getTimeSheetCategories: async (
		clientId: string,
		data: IGetListRequest,
		navigateToLogout: (path: string) => void,
	): Promise<
		| ITimeSheetCategoriesListPayload
		| IServerError
		| IResponse
		| ITimeSheetCategoriesResponse[]
	> => {
		try {
			const response: AxiosResponse<ITimeSheetCategoriesListPayload> =
				await http.get<ITimeSheetCategoriesListPayload>(
					"/v1/time-sheet-categories/?clientId=" +
						clientId +
						"&order_by=" +
						data.order_by +
						"&order_direction=" +
						data.order_direction +
						"&page=" +
						data.page +
						"&size=" +
						data.size +
						"&search_query=" +
						data.search_query,
				);

			if (response.status === 200) {
				return response.data;
			} else if (response.status === 400) {
				return {
					status: false,
					message: "Bad Request.",
					error: true,
				};
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}
			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},

	deleteTimeSheetCategory: async (
		delPayload: any,
	): Promise<string | IServerError | IResponse | any> => {
		console.log("delPayloaddelPayload", delPayload);
		try {
			const response: AxiosResponse<string> = await http.delete<string>(
				`/v1/time-sheet-categories/${delPayload.clientId}/?title=${delPayload.category.title}`,
			);

			if (response.status === 204) {
				return "Assign Employee has been deleted successfully";
			} else if (response.status === 200) {
				return "Assign Employee has been deleted successfully";
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				delPayload.navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},

	getTimeSheetCategoryTrackingById: async (
		id: string | undefined,
		navigateToLogout: (path: string) => void,
	): Promise<
		ITimeSheetCategoryTracking | IServerError | IResponse | null | any
	> => {
		if (!id) return null;
		try {
			const response: AxiosResponse<ITimeSheetCategoryTracking> =
				await http.get<ITimeSheetCategoryTracking>(
					`/v1/time-sheet-categories-track/${id}/`,
				);

			if (response.status === 200) {
				return response.data;
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},

	createTimeSheetCategoryTracking: async (
		requestPayload: any,
	): Promise<ITimeSheetCategoryTracking | IServerError | IResponse | any> => {
		if (requestPayload.id) {
			try {
				const response: AxiosResponse<ITimeSheetCategoryTracking> =
					await http.put<ITimeSheetCategoryTracking>(
						`/v1/time-sheet-categories-track/${requestPayload.id}/`,
						requestPayload,
					);

				if (response.status === 200) {
					return response;
				} else if (response.status === 400) {
					return response.data;
				} else if (response.status === 500) {
					return {
						status: false,
						message: "Something went wrong.",
						error: true,
					};
				}
			} catch (error) {
				const axiosError = error as AxiosError;
				console.error("An error occurred:", axiosError);
				const errorMessage =
					axiosError.response && typeof axiosError.response.data === "string"
						? axiosError.response.data
						: "Unknown error";
				if (axiosError && axiosError.status === 401) {
					requestPayload.navigateToLogout("/logout");
					return {
						status: false,
						message: "UnAuthrized",
					};
				} else {
					return {
						status: false,
						message: errorMessage,
					};
				}
			}
		}

		try {
			const response: AxiosResponse<ITimeSheetCategoryTracking> =
				await http.post<ITimeSheetCategories>(
					`/v1/time-sheet-categories-track/`,
					requestPayload,
				);

			if (response.status === 201) {
				return response;
			} else if (response.status === 400) {
				return response.data;
			} else if (response.status === 401) {
				// window.location.href = '/logout';
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				requestPayload.navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},

	getTimeSheetCategoryTracking: async (
		clientId: string,
		data: IGetListRequest,
		navigateToLogout: (path: string) => void,
	): Promise<
		| ITimeSheetCategoryTrackingListPayload
		| IServerError
		| IResponse
		| ITimeSheetCategoryTrackingResponse[]
	> => {
		// const RQFixedResponse: any = {
		// 	page: 1,
		// 	size: 50,
		// 	total: 1,
		// 	items: [
		// 		{
		// 			clientId: "6a0dbe2a5072589be23ba792",
		// 			categoryTitle: "string",
		// 			categoriesTrack: "Male",
		// 			id: "6a2fb6520f340bb033046bb9",
		// 		},
		// 		{
		// 			clientId: "6a0dbe2a5072589be23ba792",
		// 			categoryTitle: "string",
		// 			categoriesTrack: "She Male",
		// 			id: "6a2fb6520f340bb033046bb9",
		// 		},
		// 	],
		// 	keyField: {
		// 		field: "id",
		// 		templateUrl: "/timesheet-categories-track/setup/id",
		// 	},
		// 	headerColumns: [
		// 		{
		// 			field: "categoriesTitle",
		// 			headerName: "Category",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 0,
		// 			frozenColumn: false,
		// 			footer: null,
		// 			minWidth: null,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "categoriesTrack",
		// 			headerName: "Category Tracking",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 1,
		// 			frozenColumn: false,
		// 			footer: null,
		// 			minWidth: null,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 	],
		// };

		// return new Promise((resolve) =>
		// 	setTimeout(() => resolve(RQFixedResponse), 1000),
		// );

		try {
			const response: AxiosResponse<ITimeSheetCategoryTrackingListPayload> =
				await http.get<ITimeSheetCategoryTrackingListPayload>(
					"/v1/time-sheet-categories-track/?client_id=" +
						clientId +
						"&order_by=" +
						data.order_by +
						"&order_direction=" +
						data.order_direction +
						"&page=" +
						data.page +
						"&size=" +
						data.size +
						"&search_query=" +
						data.search_query,
				);

			if (response.status === 200) {
				return response.data;
			} else if (response.status === 400) {
				return {
					status: false,
					message: "Bad Request.",
					error: true,
				};
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}
			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},

	delTimeSheetCategoryTracking: async (
		delPayload: any,
	): Promise<string | IServerError | IResponse | any> => {
		console.log("delPayloaddelPayload", delPayload);
		try {
			const response: AxiosResponse<string> = await http.delete<string>(
				`/v1/time-sheet-categories-track/${delPayload.category.id}/`,
			);

			if (response.status === 204) {
				return "Category Tracking has been deleted successfully";
			} else if (response.status === 200) {
				return "Category Tracking has been deleted successfully";
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				delPayload.navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},
	getSelectCategoryDDL: async (
		clientId: string,
	): Promise<any | IServerError | IResponse | null> => {
		try {
			const response: AxiosResponse<any> = await http.get<any>(
				`/v1/time-sheet-categories/ddl?client_id=${clientId}`,
			);

			if (response.status === 200) {
				return response.data;
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			return {
				status: false,
				message: axiosError.response
					? axiosError.response.data
					: "Unknown error",
			};
		}
	},

	importPayrollData: async (
		requestPayload: any,
	): Promise<any | IServerError | IResponse> => {
		try {
			// const url = `/v1/payroll-xlsx-import/import-xlsx/?client_id=${requestPayload.id}&pay_period_end_date=${requestPayload.payPeriodEndDate}`;
			// const response: any = await http.post(url, requestPayload.formData, {
			//   responseType: "arraybuffer",
			//   headers: { "Content-Type": "multipart/form-data" },
			// },);
			console.log("requestPayload.formData", requestPayload.formData);

			const response = await http.post<string>(
				// `/v1/employee-csv/import-csv/?client_id=${requestPayload.id}`,
				`/v1/payroll-xlsx-import/import-xlsx/?client_id=${requestPayload.clientId}&pay_period_end_date=${requestPayload.payPeriodEndDate}`,
				requestPayload.formData,
				{ headers: { "Content-Type": "multipart/form-data" } },
			);
			if (response.status === 200) {
				return response.data;
			} else if (response.status === 201) {
				return response;
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				requestPayload.navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},
	exportpayrollExcel: async (
		tag: string,
		clientId: string,
		payPeriodFrequencyId: string | null,
		payPeriodStarDate: string | null,
		payPeriodEndDate: string | null,
		name: string,
		startsWith: string,
		department: string,
		paidBy: string,
		pageSize: number,
		page: number,
		data: IGetListRequest,
		navigateToLogout: (path: string) => void,
	): Promise<IServerError | IResponse | IPayrollResponse[] | any> => {
		if (payPeriodFrequencyId && payPeriodStarDate && payPeriodEndDate) {
			try {
				const url = `/v1/payroll-xlsx-import/download-payroll-xlsx-file?client_id=${clientId}&pay_period_frequency_id=${payPeriodFrequencyId}&pay_period_star_date=${payPeriodStarDate}&pay_period_end_date=${payPeriodEndDate}&search_query=${data.search_query}&order_by=${name}&order_direction=${data.order_direction}&starts_with=${startsWith}&department=${department}&paid_by=${paidBy}&page=${page}&size=${pageSize}`;
				const response: any = await http.get(url, {
					responseType: "arraybuffer",
				});

				if (response.status === 201) {
					return response.data;
				} else if (response.status === 200) {
					return response.data;
				} else if (response.status === 400) {
					const text = new TextDecoder().decode(response.data);
					const responseObject = JSON.parse(text);
					let response400 = {
						...response,
						data: responseObject,
					};
					return response400;
				} else if (response.status === 400) {
					return {
						status: false,
						message: "Bad Request.",
						error: true,
					};
				} else if (response.status === 500) {
					return {
						status: false,
						message: "Something went wrong.",
						error: true,
					};
				}
				return {
					status: false,
					message: "Something went wrong please try again later.",
				};
			} catch (error) {
				const axiosError = error as AxiosError;
				console.error("An error occurred:", axiosError);
				const errorMessage =
					axiosError.response && typeof axiosError.response.data === "string"
						? axiosError.response.data
						: "Unknown error";
				if (axiosError && axiosError.status === 401) {
					navigateToLogout("/logout");
					return {
						status: false,
						message: "UnAuthrized",
					};
				} else {
					return {
						status: false,
						message: errorMessage,
					};
				}
			}
		}
		return null;
	},
	setPaymentDate: async (
		requestPayload: any,
	): Promise<IPayroll | IServerError | IResponse | any> => {
		try {
			const response: AxiosResponse<IPayroll> = await http.put<IPayroll>(
				`/v1/payroll-schedule/update/set_payment_date/?payroll_schedule_id=${requestPayload.payPeriodFrequencyId}&pay_period_end_date=${requestPayload.payPeriodEndDate}&set_payment_date=${requestPayload.paymentDate}`,
			);

			if (response.status === 200) {
				return response;
			} else if (response.status === 400) {
				return response.data;
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}
			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				requestPayload.navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else if (axiosError && axiosError.status === 422) {
				return {
					status: false,
					message: `Errors : \n${format422Errors(axiosError?.response?.data)}`,
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},
};
